// HAFHToDoTranslations.js

const msmeOwnerPATranslations = {
  en: {
    gratitude: "Gratitude",
    rca: "Root Cause Analysis",
    rcaSub: "Identify issues, analyze root causes using structured RCA methods, and improve hostel operations, discipline, infrastructure, and institutional systems.",
    createRca: "Create RCA",
    rcaList: "RCA List",
    rcaDashboard: "RCA Dashboard",
    analytics: "Analytics",
    reports: "Reports",
    settings: "Settings",
    all: "All",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    thisweek: "This Week",
    lastweek: "Last Week",
    nextweek: "Next Week",
    thismonth: "This Month",
    lastmonth: "Last Month",
    nextmonth: "Next Month",
    self: "Self",
    myself: "Self RCA",
    tome: "Assigned To Me",
    fromme: "Raised By Me",
    student: "Student",
    parent: "Parent",
    owner: "Owner",
    trustee: "Trustee",
    institution: "Institution",
    mess: "Mess",
    transporter: "Transporter",
    huma: "HUMA",
    completed: "Completed",
    priority: "Priority",
    recurring: "Recurring",
    createRCA: "Create RCA",
    createRCADesc: "Capture issues, identify root causes, and track corrective actions for continuous improvement.",
    editRCA: "Edit RCA",
    updateSelectedRCA: "Update Selected RCA",
    rcaDate: "RCA Date",
    rcaType: "RCA Type",
    rcaFor: "RCA For",
    rcaBy: "RCA By",
    rcaCode: "RCA Code",
    rcaGroupCode: "RCA Group Code",
    userRCAID: "User RCA ID",
    category: "Category",
    subCategory: "Sub Category",
    concernArea: "Concern Area",
    title: "Title",
    description: "Description",
    problemStatement: "Problem Statement",
    rootCause: "Root Cause",
    summary: "Summary",
    remarks: "Remarks",
    additionalRemarks: "Additional Remarks",
    why1: "Why 1",
    why2: "Why 2",
    why3: "Why 3",
    why4: "Why 4",
    why5: "Why 5",
    quickSolutions: "Quick Solutions",
    quickSolutionsNote: "Quick Solutions Note",
    quickSolutionsSelectionNote: "Selected Solution Notes",
    quickSolutionsActionsNote: "Action Taken Notes",
    quickImpactNotes: "Quick Impact Notes",
    name: "Name",
    nameCode: "Name Code",
    whoSuggested: "Suggested By",
    enterTitle: "Enter RCA title",
    enterDescription: "Enter RCA description",
    enterRemarks: "Enter remarks",
    enterProblemStatement: "Describe the problem statement",
    enterRootCause: "Enter root cause",
    enterSummary: "Enter summary",
    enterConcernArea: "Enter concern area",
    enterTags: "e.g. discipline, consistency, growth",
    enterName: "Enter name",
    enterNameCode: "Enter name code",
    selectType: "Select Type",
    selfType: "Self",
    parentType: "Parent",
    managerType: "Manager",
    ownerType: "Owner",
    messType: "Mess",
    transportType: "Transport",
    friendType: "Friend",
    institutionType: "Institution",
    adminType: "Admin",
    humaType: "HUMA",
    othersType: "Others",
    tags: "Tags",
    addTags: "Add Tags",
    active: "Active",
    inactive: "Inactive",
    isActive: "Is Active",
    isCompleted: "Is Completed",
    isRecurring: "Is Recurring",
    isPriority: "Is Priority",
    isFinal: "Is Final",
    recurringIssue: "Recurring Issue",
    markAsCompleted: "Mark as Completed",
    refineWithAI: "Refine with AI",
    aiAssistant: "AI Assistant",
    generatedByAI: "Generated by AI",
    createdByHuman: "Created by Human",
    requiredInfoMissing: "Required Information Missing",
    pleaseFillField: "Please fill the following field",
    aiAnalysis: "AI Analysis",
    aiSuggestions: "AI Suggestions",
    aiSummary: "AI Summary",
    ttsEnabled: "TTS Enabled",
    enableTTS: "Enable Text-to-Speech",
    enableVoiceInput: "Enable Voice Input",
    speechInput: "Speech Input",
    microphoneEnabled: "Microphone Enabled",
    clickMicToSpeak: "Click the mic and speak for voice input...",
    writeHere: "Write here...",
    writeOrSpeak: "Write here or use voice input...",
    play: "Play",
    pause: "Pause",
    stop: "Stop",
    resume: "Resume",
    addRCA: "Add RCA",
    save: "Save",
    saveData: "Save",
    saving: "Saving...",
    update: "Update",
    updating: "Updating...",
    delete: "Delete",
    deleting: "Deleting...",
    cancel: "Cancel",
    edit: "Edit",
    close: "Close",
    retry: "Retry",
    savedSuccessfully: "Saved successfully",
    updatedSuccessfully: "Updated successfully",
    deletedSuccessfully: "Deleted successfully",
    saveFailed: "Save failed",
    updateFailed: "Update failed",
    deleteFailed: "Delete failed",
    failedToLoadRCA: "Failed to load RCA data",
    titleDescriptionRequired: "Title and Description are required",
    noDataFound: "No data found",
    loading: "Loading...",
    fromDate: "From Date",
    toDate: "To Date",
    completionDate: "Completion Date",
    createdAt: "Created At",
    updatedAt: "Updated At",
    actions: "Actions",
    status: "Status",
    filter: "Filter",
    search: "Search",
    viewDetails: "View Details",
    assistantCode: "Assistant Code",
    supervisorCode: "Supervisor Code",
    human: "Human",
    ai: "AI",
    reply: "Reply",
    replyDate: "Reply Date",
    addReply: "Add Reply",
    yes: "Yes",
    no: "No",
    enabled: "Enabled",
    disabled: "Disabled",

    deepThinking: "Deep Thinking",
    list: "List",
    create: "Create",
    rcaCode: "RCA Code",
    rcaFrom: "From",
    rcaTo: "To",
    linkedRCACode: "Linked RCA Code",
    linkedTaskCode: "Linked Task Code",
    teamCode: "Team Code",
    quickSolutionSelected: "Selected Quick Solution",
    quickSolutionAction: "Action Taken On Selected Solution",
    quickImpacts: "Imapct on Quick Actions",
    rcaTrend: "Causal Trend",
    monthlyAnalytics: "Monthly Analytics",
    final: "Final",
    rcaCount: "RCA Count",
    listenList: "List The List",
  },

  hi: {
    gratitude: "आभार",
    rca: "मूल कारण विश्लेषण",
    rcaSub: "संरचित RCA विधियों का उपयोग करके समस्याओं की पहचान करें, मूल कारणों का विश्लेषण करें और हॉस्टल संचालन, अनुशासन, बुनियादी ढांचे और संस्थागत प्रणालियों में सुधार करें।",
    createRca: "RCA बनाएं",
    rcaList: "RCA सूची",
    rcaDashboard: "RCA डैशबोर्ड",
    analytics: "विश्लेषण",
    reports: "रिपोर्ट्स",
    settings: "सेटिंग्स",
    all: "सभी",
    today: "आज",
    yesterday: "कल",
    tomorrow: "आने वाला कल",
    thisweek: "इस सप्ताह",
    lastweek: "पिछला सप्ताह",
    nextweek: "अगला सप्ताह",
    thismonth: "इस माह",
    lastmonth: "पिछला माह",
    nextmonth: "अगला माह",
    self: "स्वयं",
    myself: "स्वयं RCA",
    tome: "मुझे सौंपा गया",
    fromme: "मेरे द्वारा उठाया गया",
    student: "छात्र",
    parent: "अभिभावक",
    owner: "मालिक",
    trustee: "ट्रस्टी",
    institution: "संस्था",
    mess: "मेस",
    transporter: "परिवहनकर्ता",
    huma: "HUMA",
    completed: "पूर्ण",
    priority: "प्राथमिकता",
    recurring: "बार-बार होने वाला",
    createRCA: "RCA बनाएं",
    createRCADesc: "समस्याओं को दर्ज करें, मूल कारणों की पहचान करें और निरंतर सुधार के लिए सुधारात्मक कार्यों को ट्रैक करें।",
    editRCA: "RCA संपादित करें",
    updateSelectedRCA: "चयनित RCA अपडेट करें",
    rcaDate: "RCA तिथि",
    rcaType: "RCA प्रकार",
    rcaFor: "RCA हेतु",
    rcaBy: "RCA द्वारा",
    rcaCode: "RCA कोड",
    rcaGroupCode: "RCA समूह कोड",
    userRCAID: "उपयोगकर्ता RCA ID",
    category: "श्रेणी",
    subCategory: "उप-श्रेणी",
    concernArea: "चिंता क्षेत्र",
    title: "शीर्षक",
    description: "विवरण",
    problemStatement: "समस्या विवरण",
    rootCause: "मूल कारण",
    summary: "सारांश",
    remarks: "टिप्पणियाँ",
    additionalRemarks: "अतिरिक्त टिप्पणियाँ",
    why1: "क्यों 1",
    why2: "क्यों 2",
    why3: "क्यों 3",
    why4: "क्यों 4",
    why5: "क्यों 5",
    quickSolutions: "त्वरित समाधान",
    quickSolutionsNote: "त्वरित समाधान नोट",
    quickSolutionsSelectionNote: "चयनित समाधान नोट्स",
    quickSolutionsActionsNote: "किए गए कार्यों के नोट्स",
    quickImpactNotes: "त्वरित प्रभाव नोट्स",
    name: "नाम",
    nameCode: "नाम कोड",
    whoSuggested: "सुझाव देने वाला",
    enterTitle: "RCA शीर्षक दर्ज करें",
    enterDescription: "RCA विवरण दर्ज करें",
    enterRemarks: "टिप्पणियाँ दर्ज करें",
    enterProblemStatement: "समस्या विवरण लिखें",
    enterRootCause: "मूल कारण दर्ज करें",
    enterSummary: "सारांश दर्ज करें",
    enterConcernArea: "चिंता क्षेत्र दर्ज करें",
    enterTags: "उदा. अनुशासन, निरंतरता, विकास",
    enterName: "नाम दर्ज करें",
    enterNameCode: "नाम कोड दर्ज करें",
    selectType: "प्रकार चुनें",
    selfType: "स्वयं",
    parentType: "अभिभावक",
    managerType: "प्रबंधक",
    ownerType: "मालिक",
    messType: "मेस",
    transportType: "परिवहन",
    friendType: "मित्र",
    institutionType: "संस्था",
    adminType: "प्रशासक",
    humaType: "HUMA",
    othersType: "अन्य",
    tags: "टैग्स",
    addTags: "टैग जोड़ें",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    isActive: "सक्रिय है",
    isCompleted: "पूर्ण है",
    isRecurring: "बार-बार हो रहा है",
    isPriority: "प्राथमिकता है",
    isFinal: "अंतिम है",
    recurringIssue: "बार-बार होने वाली समस्या",
    markAsCompleted: "पूर्ण के रूप में चिह्नित करें",
    refineWithAI: "AI से सुधारें",
    aiAssistant: "AI सहायक",
    generatedByAI: "AI द्वारा उत्पन्न",
    createdByHuman: "मानव द्वारा बनाया गया",
    requiredInfoMissing: "आवश्यक जानकारी अनुपस्थित है",
    pleaseFillField: "कृपया निम्न फ़ील्ड भरें",
    aiAnalysis: "AI विश्लेषण",
    aiSuggestions: "AI सुझाव",
    aiSummary: "AI सारांश",
    ttsEnabled: "TTS सक्षम",
    enableTTS: "टेक्स्ट-टू-स्पीच सक्षम करें",
    enableVoiceInput: "वॉइस इनपुट सक्षम करें",
    speechInput: "वॉइस इनपुट",
    microphoneEnabled: "माइक्रोफोन सक्षम",
    clickMicToSpeak: "वॉइस इनपुट के लिए माइक्रोफोन दबाकर बोलें...",
    writeHere: "यहाँ लिखें...",
    writeOrSpeak: "यहाँ लिखें या वॉइस इनपुट का उपयोग करें...",
    play: "चलाएँ",
    pause: "रोकें",
    stop: "बंद करें",
    resume: "फिर शुरू करें",
    addRCA: "RCA जोड़ें",
    save: "सहेजें",
    saveData: "सहेजें",
    saving: "सहेजा जा रहा है...",
    update: "अपडेट करें",
    updating: "अपडेट किया जा रहा है...",
    delete: "हटाएँ",
    deleting: "हटाया जा रहा है...",
    cancel: "रद्द करें",
    edit: "संपादित करें",
    close: "बंद करें",
    retry: "पुनः प्रयास करें",
    savedSuccessfully: "सफलतापूर्वक सहेजा गया",
    updatedSuccessfully: "सफलतापूर्वक अपडेट किया गया",
    deletedSuccessfully: "सफलतापूर्वक हटाया गया",
    saveFailed: "सहेजना विफल रहा",
    updateFailed: "अपडेट विफल रहा",
    deleteFailed: "हटाना विफल रहा",
    failedToLoadRCA: "RCA डेटा लोड करने में विफल",
    titleDescriptionRequired: "शीर्षक और विवरण आवश्यक हैं",
    noDataFound: "कोई डेटा नहीं मिला",
    loading: "लोड हो रहा है...",
    fromDate: "प्रारंभ तिथि",
    toDate: "समाप्ति तिथि",
    completionDate: "पूर्णता तिथि",
    createdAt: "निर्माण तिथि",
    updatedAt: "अपडेट तिथि",
    actions: "क्रियाएँ",
    status: "स्थिति",
    filter: "फ़िल्टर",
    search: "खोजें",
    viewDetails: "विवरण देखें",
    assistantCode: "सहायक कोड",
    supervisorCode: "पर्यवेक्षक कोड",
    human: "मानव",
    ai: "AI",
    reply: "उत्तर",
    replyDate: "उत्तर तिथि",
    addReply: "उत्तर जोड़ें",
    yes: "हाँ",
    no: "नहीं",
    enabled: "सक्षम",
    disabled: "अक्षम",


  },

  mr: {
    analytics: "विश्लेषण",
    reports: "अहवाल",
    settings: "सेटिंग्ज",
    all: "सर्व",
    today: "आज",
    yesterday: "काल",
    tomorrow: "उद्या",
    thisweek: "हा आठवडा",
    lastweek: "मागील आठवडा",
    nextweek: "पुढील आठवडा",
    thismonth: "हा महिना",
    lastmonth: "मागील महिना",
    nextmonth: "पुढील महिना",
    self: "स्वतः",
    myself: "माझे स्वतःचे RCA",
    tome: "माझ्याकडे नियुक्त",
    fromme: "माझ्याकडून तयार",
    student: "विद्यार्थी",
    parent: "पालक",
    owner: "मालक",
    trustee: "विश्वस्त",
    institution: "संस्था",
    mess: "मेस",
    transporter: "वाहतूकदार",
    huma: "HUMA",
    completed: "पूर्ण",
    priority: "प्राधान्य",
    recurring: "पुन्हा पुन्हा होणारे",

    createRCA: "RCA तयार करा",
    createRCADesc: "समस्या नोंदवा, मूळ कारण शोधा आणि सतत सुधारण्यासाठी सुधारात्मक कृती ट्रॅक करा.",
    editRCA: "RCA संपादित करा",
    updateSelectedRCA: "निवडलेले RCA अद्यतनित करा",
    rcaDate: "RCA तारीख",
    rcaType: "RCA प्रकार",
    rcaFor: "RCA कोणासाठी",
    rcaBy: "RCA द्वारे",
    rcaCode: "RCA कोड",
    rcaGroupCode: "RCA गट कोड",
    userRCAID: "वापरकर्ता RCA आयडी",
    category: "श्रेणी",
    subCategory: "उपश्रेणी",
    concernArea: "समस्या क्षेत्र",
    title: "शीर्षक",
    description: "वर्णन",
    problemStatement: "समस्येचे विधान",
    rootCause: "मूळ कारण",
    summary: "सारांश",
    remarks: "टीप",
    additionalRemarks: "अतिरिक्त टीप",
    why1: "का 1",
    why2: "का 2",
    why3: "का 3",
    why4: "का 4",
    why5: "का 5",
    quickSolutions: "त्वरित उपाय",
    quickSolutionsNote: "त्वरित उपाय टीप",
    quickSolutionsSelectionNote: "निवडलेल्या उपायाची टीप",
    quickSolutionsActionsNote: "उपाय कृती टीप",
    quickImpactNotes: "त्वरित परिणाम टीप",

    name: "नाव",
    nameCode: "नाव कोड",
    who_suggested: "कोणाने सुचवले",
    enterTitle: "RCA शीर्षक प्रविष्ट करा",
    enterDescription: "RCA वर्णन प्रविष्ट करा",
    enterRemarks: "टीप प्रविष्ट करा",
    enterProblemStatement: "समस्येचे वर्णन करा",
    enterRootCause: "ओळखलेले मूळ कारण प्रविष्ट करा",
    enterSummary: "सारांश प्रविष्ट करा",
    enterConcernArea: "समस्या क्षेत्र प्रविष्ट करा",
    enterTags: "उदा. शिस्त, सातत्य, वाढ",
    enterName: "नाव प्रविष्ट करा",
    enterNameCode: "नाव कोड प्रविष्ट करा",
    selectType: "प्रकार निवडा",
    selfType: "स्वतः",
    parentType: "पालक",
    managerType: "व्यवस्थापक",
    ownerType: "मालक",
    messType: "मेस",
    transportType: "वाहतूक",
    friendType: "मित्र",
    institutionType: "संस्था",
    adminType: "प्रशासक",
    humaType: "HUMA",
    othersType: "इतर",

    tags: "टॅग्स",
    addTags: "टॅग जोडा",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    isActive: "सक्रिय आहे",
    isCompleted: "पूर्ण झाले",
    isRecurring: "पुन्हा घडणारे",
    isPriority: "प्राधान्य आहे",
    isFinal: "अंतिम आहे",
    recurringIssue: "पुन्हा होणारी समस्या",
    markAsCompleted: "पूर्ण म्हणून चिन्हांकित करा",

    refineWithAI: "AI सह सुधारणा करा",
    aiAssistant: "AI सहाय्यक",
    generatedByAI: "AI द्वारे तयार",
    createdByHuman: "मानवाने तयार केले",
    missingri: "आवश्यक माहिती उपलब्ध नाही",
    plfillthefield: "कृपया खालील फील्ड भरा",
    aiAnalysis: "AI विश्लेषण",
    aiSuggestions: "AI सूचना",
    aiSummary: "AI सारांश",
    ttsEnabled: "TTS सक्षम",
    enableTTS: "टेक्स्ट टू स्पीच सक्षम करा",
    evi: "व्हॉइस इनपुट सक्षम करा",
    speechInput: "व्हॉइस इनपुट",
    microphoneEnabled: "मायक्रोफोन सक्षम",
    clickMicToSpeak: "व्हॉइस इनपुटसाठी माइक क्लिक करा आणि बोला...",
    writeHere: "येथे लिहा...",
    writeOrSpeak: "येथे लिहा किंवा व्हॉइस इनपुटसाठी माइक क्लिक करा...",
    play: "चालू करा",
    pause: "थांबवा",
    stop: "बंद करा",
    resume: "पुन्हा सुरू करा",
    addRCA: "RCA जोडा",
    save: "जतन करा",
    saveData: "डेटा जतन करा",
    saving: "जतन होत आहे...",
    update: "अद्यतनित करा",
    updating: "अद्यतनित होत आहे...",
    delete: "हटवा",
    deleting: "हटवले जात आहे...",
    cancel: "रद्द करा",
    edit: "संपादित करा",
    close: "बंद करा",
    retry: "पुन्हा प्रयत्न करा",
    savedSuccessfully: "यशस्वीरित्या जतन केले",
    updatedSuccessfully: "यशस्वीरित्या अद्यतनित केले",
    deletedSuccessfully: "यशस्वीरित्या हटवले",
    saveFailed: "जतन अयशस्वी",
    updateFailed: "अद्यतन अयशस्वी",
    deleteFailed: "हटवणे अयशस्वी",
    failedToLoadRCA: "RCA लोड करण्यात अयशस्वी",
    titleDescriptionRequired: "शीर्षक आणि वर्णन आवश्यक",
    noDataFound: "डेटा उपलब्ध नाही",
    loading: "लोड होत आहे...",
    fromDate: "सुरुवातीची तारीख",
    toDate: "शेवटची तारीख",
    completionDate: "पूर्ण तारीख",
    createdAt: "तयार केले",
    updatedAt: "अद्यतनित केले",
    actions: "कृती",
    status: "स्थिती",
    filter: "फिल्टर",
    search: "शोधा",
    viewDetails: "तपशील पहा",
    assistantCode: "सहाय्यक कोड",
    supervisorCode: "पर्यवेक्षक कोड",

    human: "मानव",
    ai: "AI",
    reply: "उत्तर",
    replyDate: "उत्तर तारीख",
    addReply: "उत्तर जोडा",
    yes: "होय",
    no: "नाही",
    enabled: "सक्षम",
    disabled: "अक्षम",

    Gratitude: "कृतज्ञता",
    rca: "मूळ कारण विश्लेषण",
    rcaSub: "संरचित RCA पद्धती वापरून समस्या ओळखा, मूळ कारणांचे विश्लेषण करा आणि वसतिगृह संचालन, शिस्त, पायाभूत सुविधा आणि संस्थात्मक प्रणाली सुधारित करा.",
    create: "तयार करा",
    list: "यादी",
    dashboard: "डॅशबोर्ड",
  },

  gu: { 
    analytics: "વિશ્લેષણ",
    reports: "અહેવાલો",
    settings: "સેટિંગ્સ",
    all: "બધા",
    today: "આજે",
    yesterday: "ગઈકાલે",
    tomorrow: "આવતીકાલે",
    thisweek: "આ અઠવાડિયું",
    lastweek: "ગત અઠવાડિયું",
    nextweek: "આવતું અઠવાડિયું",
    thismonth: "આ મહિનો",
    lastmonth: "ગત મહિનો",
    nextmonth: "આવતો મહિનો",
    self: "સ્વ",
    myself: "મારું સ્વ RCA",
    tome: "મને સોંપાયેલ",
    fromme: "મારા દ્વારા બનાવેલ",
    student: "વિદ્યાર્થી",
    parent: "વાલી",
    owner: "માલિક",
    trustee: "ટ્રસ્ટી",
    institution: "સંસ્થા",
    mess: "મેસ",
    transporter: "પરિવહનકાર",
    huma: "HUMA",
    completed: "પૂર્ણ",
    priority: "પ્રાથમિકતા",
    recurring: "પુનરાવર્તિત",

    createRCA: "RCA બનાવો",
    createRCADesc: "સમસ્યાઓ નોંધો, મૂળ કારણો શોધો અને સતત સુધારણા માટે સુધારાત્મક કાર્યવાહી ટ્રેક કરો.",
    editRCA: "RCA સંપાદિત કરો",
    updateSelectedRCA: "પસંદ કરેલ RCA અપડેટ કરો",
    rcaDate: "RCA તારીખ",
    rcaType: "RCA પ્રકાર",
    rcaFor: "RCA માટે",
    rcaBy: "RCA દ્વારા",
    rcaCode: "RCA કોડ",
    rcaGroupCode: "RCA ગ્રુપ કોડ",
    userRCAID: "વપરાશકર્તા RCA આઈડી",
    category: "શ્રેણી",
    subCategory: "ઉપશ્રેણી",
    concernArea: "ચિંતા ક્ષેત્ર",
    title: "શીર્ષક",
    description: "વર્ણન",
    problemStatement: "સમસ્યા નિવેદન",
    rootCause: "મૂળ કારણ",
    summary: "સારાંશ",
    remarks: "ટિપ્પણીઓ",
    additionalRemarks: "વધારાની ટિપ્પણીઓ",
    why1: "શા માટે 1",
    why2: "શા માટે 2",
    why3: "શા માટે 3",
    why4: "શા માટે 4",
    why5: "શા માટે 5",
    quickSolutions: "ઝડપી ઉકેલો",
    quickSolutionsNote: "ઝડપી ઉકેલ નોંધ",
    quickSolutionsSelectionNote: "પસંદ કરેલ ઉકેલ નોંધ",
    quickSolutionsActionsNote: "ઉકેલ કાર્યવાહી નોંધ",
    quickImpactNotes: "ઝડપી અસર નોંધ",

    name: "નામ",
    nameCode: "નામ કોડ",
    who_suggested: "કોણે સૂચન કર્યું",
    enterTitle: "RCA શીર્ષક દાખલ કરો",
    enterDescription: "RCA વર્ણન દાખલ કરો",
    enterRemarks: "ટિપ્પણીઓ દાખલ કરો",
    enterProblemStatement: "સમસ્યાનું વર્ણન કરો",
    enterRootCause: "ઓળખાયેલ મૂળ કારણ દાખલ કરો",
    enterSummary: "સારાંશ દાખલ કરો",
    enterConcernArea: "ચિંતા ક્ષેત્ર દાખલ કરો",
    enterTags: "દા.ત. શિસ્ત, સતતતા, વિકાસ",
    enterName: "નામ દાખલ કરો",
    enterNameCode: "નામ કોડ દાખલ કરો",
    selectType: "પ્રકાર પસંદ કરો",
    selfType: "સ્વ",
    parentType: "વાલી",
    managerType: "મેનેજર",
    ownerType: "માલિક",
    messType: "મેસ",
    transportType: "પરિવહન",
    friendType: "મિત્ર",
    institutionType: "સંસ્થા",
    adminType: "એડમિન",
    humaType: "HUMA",
    othersType: "અન્ય",

    tags: "ટેગ્સ",
    addTags: "ટેગ્સ ઉમેરો",
    active: "સક્રિય",
    inactive: "નિષ્ક્રિય",
    isActive: "સક્રિય છે",
    isCompleted: "પૂર્ણ થયું",
    isRecurring: "પુનરાવર્તિત છે",
    isPriority: "પ્રાથમિકતા છે",
    isFinal: "અંતિમ છે",
    recurringIssue: "પુનરાવર્તિત સમસ્યા",
    markAsCompleted: "પૂર્ણ તરીકે ચિહ્નિત કરો",

    refineWithAI: "AI સાથે સુધારો",
    aiAssistant: "AI સહાયક",
    generatedByAI: "AI દ્વારા બનાવેલ",
    createdByHuman: "માનવ દ્વારા બનાવેલ",
    missingri: "આવશ્યક માહિતી ઉપલબ્ધ નથી",
    plfillthefield: "કૃપા કરીને નીચેનું ફીલ્ડ ભરો",
    aiAnalysis: "AI વિશ્લેષણ",
    aiSuggestions: "AI સૂચનો",
    aiSummary: "AI સારાંશ",
    ttsEnabled: "TTS સક્રિય",
    enableTTS: "ટેક્સ્ટ ટુ સ્પીચ સક્રિય કરો",
    evi: "વોઇસ ઇનપુટ સક્રિય કરો",
    speechInput: "વોઇસ ઇનપુટ",
    microphoneEnabled: "માઇક્રોફોન સક્રિય",
    clickMicToSpeak: "વોઇસ ઇનપુટ માટે માઇક ક્લિક કરો અને બોલો...",
    writeHere: "અહીં લખો...",
    writeOrSpeak: "અહીં લખો અથવા વોઇસ ઇનપુટ માટે માઇક ક્લિક કરો...",
    play: "ચાલુ કરો",
    pause: "થોભાવો",
    stop: "બંધ કરો",
    resume: "ફરી શરૂ કરો",
    addRCA: "RCA ઉમેરો",
    save: "સાચવો",
    saveData: "ડેટા સાચવો",
    saving: "સાચવાઈ રહ્યું છે...",
    update: "અપડેટ કરો",
    updating: "અપડેટ થઈ રહ્યું છે...",
    delete: "કાઢી નાખો",
    deleting: "કાઢી નાખવામાં આવી રહ્યું છે...",
    cancel: "રદ કરો",
    edit: "સંપાદિત કરો",
    close: "બંધ કરો",
    retry: "ફરી પ્રયાસ કરો",
    savedSuccessfully: "સફળતાપૂર્વક સાચવ્યું",
    updatedSuccessfully: "સફળતાપૂર્વક અપડેટ કર્યું",
    deletedSuccessfully: "સફળતાપૂર્વક કાઢી નાખ્યું",
    saveFailed: "સાચવવામાં નિષ્ફળ",
    updateFailed: "અપડેટ કરવામાં નિષ્ફળ",
    deleteFailed: "કાઢી નાખવામાં નિષ્ફળ",
    failedToLoadRCA: "RCA લોડ કરવામાં નિષ્ફળ",
    titleDescriptionRequired: "શીર્ષક અને વર્ણન જરૂરી છે",
    noDataFound: "કોઈ ડેટા મળ્યો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    fromDate: "શરૂઆત તારીખ",
    toDate: "અંતિમ તારીખ",
    completionDate: "પૂર્ણ તારીખ",
    createdAt: "બનાવ્યું",
    updatedAt: "અપડેટ કર્યું",
    actions: "ક્રિયાઓ",
    status: "સ્થિતિ",
    filter: "ફિલ્ટર",
    search: "શોધો",
    viewDetails: "વિગતો જુઓ",
    assistantCode: "સહાયક કોડ",
    supervisorCode: "સુપરવાઇઝર કોડ",

    human: "માનવ",
    ai: "AI",
    reply: "જવાબ",
    replyDate: "જવાબ તારીખ",
    addReply: "જવાબ ઉમેરો",
    yes: "હા",
    no: "ના",
    enabled: "સક્રિય",
    disabled: "નિષ્ક્રિય",

    Gratitude: "કૃતજ્ઞતા",
    rca: "મૂળ કારણ વિશ્લેષણ",
    rcaSub: "રચનાત્મક RCA પદ્ધતિઓનો ઉપયોગ કરીને સમસ્યાઓ ઓળખો, મૂળ કારણોનું વિશ્લેષણ કરો અને હોસ્ટેલ કામગીરી, શિસ્ત, ઇન્ફ્રાસ્ટ્રક્ચર અને સંસ્થાકીય સિસ્ટમોમાં સુધારો કરો.",
    create: "બનાવો",
    list: "યાદી",
    dashboard: "ડેશબોર્ડ",
  },

  bn: {
    analytics: "বিশ্লেষণ",
    reports: "রিপোর্ট",
    settings: "সেটিংস",
    all: "সব",
    today: "আজ",
    yesterday: "গতকাল",
    tomorrow: "আগামীকাল",
    thisweek: "এই সপ্তাহ",
    lastweek: "গত সপ্তাহ",
    nextweek: "পরবর্তী সপ্তাহ",
    thismonth: "এই মাস",
    lastmonth: "গত মাস",
    nextmonth: "পরবর্তী মাস",
    self: "নিজ",
    myself: "আমার নিজস্ব RCA",
    tome: "আমার কাছে বরাদ্দ",
    fromme: "আমার দ্বারা তৈরি",
    student: "ছাত্র",
    parent: "অভিভাবক",
    owner: "মালিক",
    trustee: "ট্রাস্টি",
    institution: "প্রতিষ্ঠান",
    mess: "মেস",
    transporter: "পরিবহনকারী",
    huma: "HUMA",
    completed: "সম্পন্ন",
    priority: "অগ্রাধিকার",
    recurring: "পুনরাবৃত্ত",

    createRCA: "RCA তৈরি করুন",
    createRCADesc: "সমস্যা শনাক্ত করুন, মূল কারণ বিশ্লেষণ করুন এবং ধারাবাহিক উন্নতির জন্য সংশোধনী কার্যক্রম ট্র্যাক করুন।",
    editRCA: "RCA সম্পাদনা করুন",
    updateSelectedRCA: "নির্বাচিত RCA আপডেট করুন",
    rcaDate: "RCA তারিখ",
    rcaType: "RCA ধরণ",
    rcaFor: "RCA কার জন্য",
    rcaBy: "RCA দ্বারা",
    rcaCode: "RCA কোড",
    rcaGroupCode: "RCA গ্রুপ কোড",
    userRCAID: "ব্যবহারকারী RCA আইডি",
    category: "বিভাগ",
    subCategory: "উপবিভাগ",
    concernArea: "সমস্যার ক্ষেত্র",
    title: "শিরোনাম",
    description: "বর্ণনা",
    problemStatement: "সমস্যার বিবৃতি",
    rootCause: "মূল কারণ",
    summary: "সারাংশ",
    remarks: "মন্তব্য",
    additionalRemarks: "অতিরিক্ত মন্তব্য",
    why1: "কেন ১",
    why2: "কেন ২",
    why3: "কেন ৩",
    why4: "কেন ৪",
    why5: "কেন ৫",
    quickSolutions: "দ্রুত সমাধান",
    quickSolutionsNote: "দ্রুত সমাধান নোট",
    quickSolutionsSelectionNote: "নির্বাচিত সমাধান নোট",
    quickSolutionsActionsNote: "সমাধান কার্যক্রম নোট",
    quickImpactNotes: "দ্রুত প্রভাব নোট",

    name: "নাম",
    nameCode: "নাম কোড",
    who_suggested: "কে পরামর্শ দিয়েছে",
    enterTitle: "RCA শিরোনাম লিখুন",
    enterDescription: "RCA বর্ণনা লিখুন",
    enterRemarks: "মন্তব্য লিখুন",
    enterProblemStatement: "সমস্যার বিবরণ দিন",
    enterRootCause: "চিহ্নিত মূল কারণ লিখুন",
    enterSummary: "সারাংশ লিখুন",
    enterConcernArea: "সমস্যার ক্ষেত্র লিখুন",
    enterTags: "যেমন শৃঙ্খলা, ধারাবাহিকতা, উন্নতি",
    enterName: "নাম লিখুন",
    enterNameCode: "নাম কোড লিখুন",
    selectType: "ধরণ নির্বাচন করুন",
    selfType: "নিজ",
    parentType: "অভিভাবক",
    managerType: "ম্যানেজার",
    ownerType: "মালিক",
    messType: "মেস",
    transportType: "পরিবহন",
    friendType: "বন্ধু",
    institutionType: "প্রতিষ্ঠান",
    adminType: "অ্যাডমিন",
    humaType: "HUMA",
    othersType: "অন্যান্য",

    tags: "ট্যাগ",
    addTags: "ট্যাগ যোগ করুন",
    active: "সক্রিয়",
    inactive: "নিষ্ক্রিয়",
    isActive: "সক্রিয় আছে",
    isCompleted: "সম্পন্ন হয়েছে",
    isRecurring: "পুনরাবৃত্ত হচ্ছে",
    isPriority: "অগ্রাধিকারপ্রাপ্ত",
    isFinal: "চূড়ান্ত",
    recurringIssue: "পুনরাবৃত্ত সমস্যা",
    markAsCompleted: "সম্পন্ন হিসেবে চিহ্নিত করুন",

    refineWithAI: "AI দিয়ে উন্নত করুন",
    aiAssistant: "AI সহকারী",
    generatedByAI: "AI দ্বারা তৈরি",
    createdByHuman: "মানুষ দ্বারা তৈরি",
    missingri: "প্রয়োজনীয় তথ্য অনুপস্থিত",
    plfillthefield: "অনুগ্রহ করে নিম্নলিখিত ক্ষেত্র পূরণ করুন",
    aiAnalysis: "AI বিশ্লেষণ",
    aiSuggestions: "AI পরামর্শ",
    aiSummary: "AI সারাংশ",
    ttsEnabled: "TTS সক্রিয়",
    enableTTS: "টেক্সট টু স্পিচ সক্রিয় করুন",
    evi: "ভয়েস ইনপুট সক্রিয় করুন",
    speechInput: "ভয়েস ইনপুট",
    microphoneEnabled: "মাইক্রোফোন সক্রিয়",
    clickMicToSpeak: "ভয়েস ইনপুটের জন্য মাইক্রোফোনে ক্লিক করে বলুন...",
    writeHere: "এখানে লিখুন...",
    writeOrSpeak: "এখানে লিখুন অথবা ভয়েস ইনপুটের জন্য মাইক্রোফোনে ক্লিক করুন...",
    play: "চালান",
    pause: "বিরতি",
    stop: "বন্ধ করুন",
    resume: "পুনরায় শুরু করুন",
    addRCA: "RCA যোগ করুন",
    save: "সংরক্ষণ করুন",
    saveData: "ডেটা সংরক্ষণ করুন",
    saving: "সংরক্ষণ হচ্ছে...",
    update: "আপডেট করুন",
    updating: "আপডেট হচ্ছে...",
    delete: "মুছুন",
    deleting: "মুছে ফেলা হচ্ছে...",
    cancel: "বাতিল",
    edit: "সম্পাদনা",
    close: "বন্ধ",
    retry: "পুনরায় চেষ্টা করুন",
    savedSuccessfully: "সফলভাবে সংরক্ষিত হয়েছে",
    updatedSuccessfully: "সফলভাবে আপডেট হয়েছে",
    deletedSuccessfully: "সফলভাবে মুছে ফেলা হয়েছে",
    saveFailed: "সংরক্ষণ ব্যর্থ হয়েছে",
    updateFailed: "আপডেট ব্যর্থ হয়েছে",
    deleteFailed: "মুছে ফেলা ব্যর্থ হয়েছে",
    failedToLoadRCA: "RCA লোড করতে ব্যর্থ হয়েছে",
    titleDescriptionRequired: "শিরোনাম এবং বর্ণনা প্রয়োজন",
    noDataFound: "কোনো ডেটা পাওয়া যায়নি",
    loading: "লোড হচ্ছে...",
    fromDate: "শুরুর তারিখ",
    toDate: "শেষ তারিখ",
    completionDate: "সম্পন্নের তারিখ",
    createdAt: "তৈরি হয়েছে",
    updatedAt: "আপডেট হয়েছে",
    actions: "কার্যক্রম",
    status: "অবস্থা",
    filter: "ফিল্টার",
    search: "অনুসন্ধান",
    viewDetails: "বিস্তারিত দেখুন",
    assistantCode: "সহকারী কোড",
    supervisorCode: "সুপারভাইজার কোড",

    human: "মানুষ",
    ai: "AI",
    reply: "উত্তর",
    replyDate: "উত্তরের তারিখ",
    addReply: "উত্তর যোগ করুন",
    yes: "হ্যাঁ",
    no: "না",
    enabled: "সক্রিয়",
    disabled: "নিষ্ক্রিয়",

    Gratitude: "কৃতজ্ঞতা",
    rca: "মূল কারণ বিশ্লেষণ",
    rcaSub: "গঠনমূলক RCA পদ্ধতি ব্যবহার করে সমস্যা শনাক্ত করুন, মূল কারণ বিশ্লেষণ করুন এবং হোস্টেল পরিচালনা, শৃঙ্খলা, অবকাঠামো ও প্রাতিষ্ঠানিক ব্যবস্থার উন্নতি করুন।",
    create: "তৈরি করুন",
    list: "তালিকা",
    dashboard: "ড্যাশবোর্ড",
  },

  ta: {
    analytics: "பகுப்பாய்வு",
    reports: "அறிக்கைகள்",
    settings: "அமைப்புகள்",
    all: "அனைத்தும்",
    today: "இன்று",
    yesterday: "நேற்று",
    tomorrow: "நாளை",
    thisweek: "இந்த வாரம்",
    lastweek: "கடந்த வாரம்",
    nextweek: "அடுத்த வாரம்",
    thismonth: "இந்த மாதம்",
    lastmonth: "கடந்த மாதம்",
    nextmonth: "அடுத்த மாதம்",
    self: "சுயம்",
    myself: "எனது சொந்த RCA",
    tome: "எனக்கு ஒதுக்கப்பட்டது",
    fromme: "என்னால் உருவாக்கப்பட்டது",
    student: "மாணவர்",
    parent: "பெற்றோர்",
    owner: "உரிமையாளர்",
    trustee: "அறங்காவலர்",
    institution: "நிறுவனம்",
    mess: "மெஸ்",
    transporter: "போக்குவரத்தாளர்",
    huma: "HUMA",
    completed: "முடிந்தது",
    priority: "முன்னுரிமை",
    recurring: "மீண்டும் நிகழும்",

    createRCA: "RCA உருவாக்கு",
    createRCADesc: "பிரச்சினைகளை அடையாளம் கண்டு, மூல காரணங்களை பகுப்பாய்வு செய்து, தொடர்ந்து மேம்படுத்துவதற்கான திருத்த நடவடிக்கைகளை கண்காணிக்கவும்.",
    editRCA: "RCA திருத்து",
    updateSelectedRCA: "தேர்ந்தெடுக்கப்பட்ட RCA-ஐ புதுப்பிக்கவும்",
    rcaDate: "RCA தேதி",
    rcaType: "RCA வகை",
    rcaFor: "RCA யாருக்காக",
    rcaBy: "RCA உருவாக்கியது",
    rcaCode: "RCA குறியீடு",
    rcaGroupCode: "RCA குழு குறியீடு",
    userRCAID: "பயனர் RCA ஐடி",
    category: "வகை",
    subCategory: "துணை வகை",
    concernArea: "கவலை பகுதி",
    title: "தலைப்பு",
    description: "விளக்கம்",
    problemStatement: "பிரச்சினை விளக்கம்",
    rootCause: "மூல காரணம்",
    summary: "சுருக்கம்",
    remarks: "குறிப்புகள்",
    additionalRemarks: "கூடுதல் குறிப்புகள்",
    why1: "ஏன் 1",
    why2: "ஏன் 2",
    why3: "ஏன் 3",
    why4: "ஏன் 4",
    why5: "ஏன் 5",
    quickSolutions: "விரைவு தீர்வுகள்",
    quickSolutionsNote: "விரைவு தீர்வு குறிப்பு",
    quickSolutionsSelectionNote: "தேர்ந்தெடுத்த தீர்வு குறிப்பு",
    quickSolutionsActionsNote: "தீர்வு நடவடிக்கை குறிப்பு",
    quickImpactNotes: "விரைவு விளைவு குறிப்பு",

    name: "பெயர்",
    nameCode: "பெயர் குறியீடு",
    who_suggested: "யார் பரிந்துரைத்தார்",
    enterTitle: "RCA தலைப்பை உள்ளிடவும்",
    enterDescription: "RCA விளக்கத்தை உள்ளிடவும்",
    enterRemarks: "குறிப்புகளை உள்ளிடவும்",
    enterProblemStatement: "பிரச்சினையை விவரிக்கவும்",
    enterRootCause: "அடையாளம் காணப்பட்ட மூல காரணத்தை உள்ளிடவும்",
    enterSummary: "சுருக்கத்தை உள்ளிடவும்",
    enterConcernArea: "கவலை பகுதியை உள்ளிடவும்",
    enterTags: "உதா: ஒழுக்கம், தொடர்ச்சி, வளர்ச்சி",
    enterName: "பெயரை உள்ளிடவும்",
    enterNameCode: "பெயர் குறியீட்டை உள்ளிடவும்",
    selectType: "வகையை தேர்வு செய்யவும்",
    selfType: "சுயம்",
    parentType: "பெற்றோர்",
    managerType: "மேலாளர்",
    ownerType: "உரிமையாளர்",
    messType: "மெஸ்",
    transportType: "போக்குவரத்து",
    friendType: "நண்பர்",
    institutionType: "நிறுவனம்",
    adminType: "நிர்வாகி",
    humaType: "HUMA",
    othersType: "மற்றவை",

    tags: "டேக்குகள்",
    addTags: "டேக்குகளைச் சேர்க்கவும்",
    active: "செயலில்",
    inactive: "செயலற்றது",
    isActive: "செயலில் உள்ளது",
    isCompleted: "முடிக்கப்பட்டது",
    isRecurring: "மீண்டும் நிகழ்கிறது",
    isPriority: "முன்னுரிமை உள்ளது",
    isFinal: "இறுதி",
    recurringIssue: "மீண்டும் நிகழும் பிரச்சினை",
    markAsCompleted: "முடிந்ததாக குறிக்கவும்",

    refineWithAI: "AI மூலம் மேம்படுத்து",
    aiAssistant: "AI உதவியாளர்",
    generatedByAI: "AI மூலம் உருவாக்கப்பட்டது",
    createdByHuman: "மனிதனால் உருவாக்கப்பட்டது",
    missingri: "தேவையான தகவல் இல்லை",
    plfillthefield: "தயவுசெய்து பின்வரும் புலத்தை நிரப்பவும்",
    aiAnalysis: "AI பகுப்பாய்வு",
    aiSuggestions: "AI பரிந்துரைகள்",
    aiSummary: "AI சுருக்கம்",
    ttsEnabled: "TTS செயல்படுத்தப்பட்டது",
    enableTTS: "உரை-ஒலி வசதியை செயல்படுத்து",
    evi: "குரல் உள்ளீட்டை செயல்படுத்து",
    speechInput: "குரல் உள்ளீடு",
    microphoneEnabled: "மைக்ரோஃபோன் செயல்படுத்தப்பட்டது",
    clickMicToSpeak: "குரல் உள்ளீட்டிற்காக மைக்ரோஃபோனை அழுத்தி பேசவும்...",
    writeHere: "இங்கே எழுதவும்...",
    writeOrSpeak: "இங்கே எழுதவும் அல்லது குரல் உள்ளீட்டிற்காக மைக்ரோஃபோனை அழுத்தவும்...",
    play: "இயக்கு",
    pause: "இடைநிறுத்து",
    stop: "நிறுத்து",
    resume: "மீண்டும் தொடங்கு",
    addRCA: "RCA சேர்க்கவும்",
    save: "சேமிக்கவும்",
    saveData: "தரவை சேமிக்கவும்",
    saving: "சேமிக்கப்படுகிறது...",
    update: "புதுப்பிக்கவும்",
    updating: "புதுப்பிக்கப்படுகிறது...",
    delete: "நீக்கு",
    deleting: "நீக்கப்படுகிறது...",
    cancel: "ரத்து செய்",
    edit: "திருத்து",
    close: "மூடு",
    retry: "மீண்டும் முயற்சி செய்",
    savedSuccessfully: "வெற்றிகரமாக சேமிக்கப்பட்டது",
    updatedSuccessfully: "வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    deletedSuccessfully: "வெற்றிகரமாக நீக்கப்பட்டது",
    saveFailed: "சேமித்தல் தோல்வியடைந்தது",
    updateFailed: "புதுப்பித்தல் தோல்வியடைந்தது",
    deleteFailed: "நீக்குதல் தோல்வியடைந்தது",
    failedToLoadRCA: "RCA ஏற்ற முடியவில்லை",
    titleDescriptionRequired: "தலைப்பும் விளக்கமும் அவசியம்",
    noDataFound: "தரவு இல்லை",
    loading: "ஏற்றப்படுகிறது...",
    fromDate: "தொடக்க தேதி",
    toDate: "முடிவு தேதி",
    completionDate: "முடிந்த தேதி",
    createdAt: "உருவாக்கப்பட்ட தேதி",
    updatedAt: "புதுப்பிக்கப்பட்ட தேதி",
    actions: "செயல்கள்",
    status: "நிலை",
    filter: "வடிகட்டி",
    search: "தேடு",
    viewDetails: "விவரங்களை காண்க",
    assistantCode: "உதவியாளர் குறியீடு",
    supervisorCode: "மேற்பார்வையாளர் குறியீடு",

    human: "மனிதர்",
    ai: "AI",
    reply: "பதில்",
    replyDate: "பதில் தேதி",
    addReply: "பதில் சேர்க்கவும்",
    yes: "ஆம்",
    no: "இல்லை",
    enabled: "செயல்படுத்தப்பட்டது",
    disabled: "செயலற்றது",

    Gratitude: "நன்றியுணர்வு",
    rca: "மூல காரண பகுப்பாய்வு",
    rcaSub: "கட்டமைக்கப்பட்ட RCA முறைகளைப் பயன்படுத்தி பிரச்சினைகளை அடையாளம் கண்டு, மூல காரணங்களை பகுப்பாய்வு செய்து, விடுதி நிர்வாகம், ஒழுக்கம், உள்கட்டமைப்பு மற்றும் நிறுவன அமைப்புகளை மேம்படுத்தவும்.",
    create: "உருவாக்கு",
    list: "பட்டியல்",
    dashboard: "டாஷ்போர்டு",
  },

  te: {
    analytics: "విశ్లేషణ",
    reports: "నివేదికలు",
    settings: "సెట్టింగ్స్",
    all: "అన్నీ",
    today: "ఈ రోజు",
    yesterday: "నిన్న",
    tomorrow: "రేపు",
    thisweek: "ఈ వారం",
    lastweek: "గత వారం",
    nextweek: "తదుపరి వారం",
    thismonth: "ఈ నెల",
    lastmonth: "గత నెల",
    nextmonth: "తదుపరి నెల",
    self: "స్వయం",
    myself: "నా స్వంత RCA",
    tome: "నాకు కేటాయించబడినవి",
    fromme: "నా ద్వారా సృష్టించబడినవి",
    student: "విద్యార్థి",
    parent: "తల్లిదండ్రులు",
    owner: "యజమాని",
    trustee: "ట్రస్టీ",
    institution: "సంస్థ",
    mess: "మెస్",
    transporter: "రవాణాదారు",
    huma: "HUMA",
    completed: "పూర్తయింది",
    priority: "ప్రాధాన్యత",
    recurring: "పునరావృతమయ్యే",

    createRCA: "RCA సృష్టించండి",
    createRCADesc: "సమస్యలను గుర్తించండి, మూల కారణాలను విశ్లేషించండి మరియు నిరంతర మెరుగుదల కోసం సరిదిద్దే చర్యలను ట్రాక్ చేయండి.",
    editRCA: "RCA సవరించండి",
    updateSelectedRCA: "ఎంచుకున్న RCA ను నవీకరించండి",
    rcaDate: "RCA తేదీ",
    rcaType: "RCA రకం",
    rcaFor: "RCA ఎవరికోసం",
    rcaBy: "RCA రూపొందించినది",
    rcaCode: "RCA కోడ్",
    rcaGroupCode: "RCA గ్రూప్ కోడ్",
    userRCAID: "యూజర్ RCA ఐడి",
    category: "వర్గం",
    subCategory: "ఉప వర్గం",
    concernArea: "సమస్య ప్రాంతం",
    title: "శీర్షిక",
    description: "వివరణ",
    problemStatement: "సమస్య వివరణ",
    rootCause: "మూల కారణం",
    summary: "సారాంశం",
    remarks: "వ్యాఖ్యలు",
    additionalRemarks: "అదనపు వ్యాఖ్యలు",
    why1: "ఎందుకు 1",
    why2: "ఎందుకు 2",
    why3: "ఎందుకు 3",
    why4: "ఎందుకు 4",
    why5: "ఎందుకు 5",
    quickSolutions: "త్వరిత పరిష్కారాలు",
    quickSolutionsNote: "త్వరిత పరిష్కార గమనిక",
    quickSolutionsSelectionNote: "ఎంచుకున్న పరిష్కార గమనిక",
    quickSolutionsActionsNote: "పరిష్కార చర్య గమనిక",
    quickImpactNotes: "త్వరిత ప్రభావ గమనికలు",

    name: "పేరు",
    nameCode: "పేరు కోడ్",
    who_suggested: "ఎవరు సూచించారు",
    enterTitle: "RCA శీర్షిక నమోదు చేయండి",
    enterDescription: "RCA వివరణ నమోదు చేయండి",
    enterRemarks: "వ్యాఖ్యలు నమోదు చేయండి",
    enterProblemStatement: "సమస్యను వివరించండి",
    enterRootCause: "గుర్తించిన మూల కారణాన్ని నమోదు చేయండి",
    enterSummary: "సారాంశాన్ని నమోదు చేయండి",
    enterConcernArea: "సమస్య ప్రాంతాన్ని నమోదు చేయండి",
    enterTags: "ఉదా: క్రమశిక్షణ, స్థిరత్వం, అభివృద్ధి",
    enterName: "పేరు నమోదు చేయండి",
    enterNameCode: "పేరు కోడ్ నమోదు చేయండి",
    selectType: "రకాన్ని ఎంచుకోండి",
    selfType: "స్వయం",
    parentType: "తల్లిదండ్రులు",
    managerType: "మేనేజర్",
    ownerType: "యజమాని",
    messType: "మెస్",
    transportType: "రవాణా",
    friendType: "స్నేహితుడు",
    institutionType: "సంస్థ",
    adminType: "అడ్మిన్",
    humaType: "HUMA",
    othersType: "ఇతరులు",

    tags: "ట్యాగులు",
    addTags: "ట్యాగులు జోడించండి",
    active: "సక్రియం",
    inactive: "నిష్క్రియం",
    isActive: "సక్రియంగా ఉంది",
    isCompleted: "పూర్తయింది",
    isRecurring: "పునరావృతమవుతోంది",
    isPriority: "ప్రాధాన్యత ఉంది",
    isFinal: "చివరి",
    recurringIssue: "పునరావృత సమస్య",
    markAsCompleted: "పూర్తయిందిగా గుర్తించండి",

    refineWithAI: "AI తో మెరుగుపరచండి",
    aiAssistant: "AI సహాయకుడు",
    generatedByAI: "AI ద్వారా రూపొందించబడింది",
    createdByHuman: "మనిషి ద్వారా రూపొందించబడింది",
    missingri: "అవసరమైన సమాచారం లేదు",
    plfillthefield: "దయచేసి క్రింది ఫీల్డ్‌ను పూరించండి",
    aiAnalysis: "AI విశ్లేషణ",
    aiSuggestions: "AI సూచనలు",
    aiSummary: "AI సారాంశం",
    ttsEnabled: "TTS ప్రారంభించబడింది",
    enableTTS: "టెక్స్ట్ టు స్పీచ్ ప్రారంభించండి",
    evi: "వాయిస్ ఇన్‌పుట్ ప్రారంభించండి",
    speechInput: "వాయిస్ ఇన్‌పుట్",
    microphoneEnabled: "మైక్రోఫోన్ ప్రారంభించబడింది",
    clickMicToSpeak: "వాయిస్ ఇన్‌పుట్ కోసం మైక్రోఫోన్‌ను క్లిక్ చేసి మాట్లాడండి...",
    writeHere: "ఇక్కడ వ్రాయండి...",
    writeOrSpeak: "ఇక్కడ వ్రాయండి లేదా వాయిస్ ఇన్‌పుట్ కోసం మైక్రోఫోన్‌ను క్లిక్ చేయండి...",
    play: "ప్లే",
    pause: "విరామం",
    stop: "ఆపు",
    resume: "మళ్లీ ప్రారంభించు",
    addRCA: "RCA జోడించండి",
    save: "సేవ్ చేయండి",
    saveData: "డేటాను సేవ్ చేయండి",
    saving: "సేవ్ అవుతోంది...",
    update: "నవీకరించండి",
    updating: "నవీకరించబడుతోంది...",
    delete: "తొలగించండి",
    deleting: "తొలగించబడుతోంది...",
    cancel: "రద్దు",
    edit: "సవరించు",
    close: "మూసివేయి",
    retry: "మళ్లీ ప్రయత్నించండి",
    savedSuccessfully: "విజయవంతంగా సేవ్ చేయబడింది",
    updatedSuccessfully: "విజయవంతంగా నవీకరించబడింది",
    deletedSuccessfully: "విజయవంతంగా తొలగించబడింది",
    saveFailed: "సేవ్ విఫలమైంది",
    updateFailed: "నవీకరణ విఫలమైంది",
    deleteFailed: "తొలగింపు విఫలమైంది",
    failedToLoadRCA: "RCA లోడ్ చేయడంలో విఫలమైంది",
    titleDescriptionRequired: "శీర్షిక మరియు వివరణ అవసరం",
    noDataFound: "డేటా కనుగొనబడలేదు",
    loading: "లోడ్ అవుతోంది...",
    fromDate: "ప్రారంభ తేదీ",
    toDate: "ముగింపు తేదీ",
    completionDate: "పూర్తి తేదీ",
    createdAt: "సృష్టించబడింది",
    updatedAt: "నవీకరించబడింది",
    actions: "చర్యలు",
    status: "స్థితి",
    filter: "ఫిల్టర్",
    search: "శోధించండి",
    viewDetails: "వివరాలు చూడండి",
    assistantCode: "సహాయక కోడ్",
    supervisorCode: "పర్యవేక్షక కోడ్",

    human: "మనిషి",
    ai: "AI",
    reply: "సమాధానం",
    replyDate: "సమాధాన తేదీ",
    addReply: "సమాధానం జోడించండి",
    yes: "అవును",
    no: "కాదు",
    enabled: "ప్రారంభించబడింది",
    disabled: "నిలిపివేయబడింది",

    Gratitude: "కృతజ్ఞత",
    rca: "మూల కారణ విశ్లేషణ",
    rcaSub: "నిర్మిత RCA పద్ధతులను ఉపయోగించి సమస్యలను గుర్తించండి, మూల కారణాలను విశ్లేషించండి మరియు హాస్టల్ నిర్వహణ, క్రమశిక్షణ, మౌలిక సదుపాయాలు మరియు సంస్థాగత వ్యవస్థలను మెరుగుపరచండి.",
    create: "సృష్టించండి",
    list: "జాబితా",
    dashboard: "డ్యాష్‌బోర్డ్",   
  },

  kn: {
    analytics:"ವಿಶ್ಲೇಷಣೆ",
    reports:"ವರದಿಗಳು",
    settings:"ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    all:"ಎಲ್ಲಾ",
    today:"ಇಂದು",
    yesterday:"ನಿನ್ನೆ",
    tomorrow:"ನಾಳೆ",
    thisweek:"ಈ ವಾರ",
    lastweek:"ಕಳೆದ ವಾರ",
    nextweek:"ಮುಂದಿನ ವಾರ",
    thismonth:"ಈ ತಿಂಗಳು",
    lastmonth:"ಕಳೆದ ತಿಂಗಳು",
    nextmonth:"ಮುಂದಿನ ತಿಂಗಳು",
    self:"ಸ್ವಯಂ",
    myself:"ನನ್ನ ಸ್ವಂತ RCA",
    tome:"ನನಗೆ ನಿಯೋಜಿಸಲಾಗಿದೆ",
    fromme:"ನನ್ನಿಂದ ರಚಿಸಲಾಗಿದೆ",
    student:"ವಿದ್ಯಾರ್ಥಿ",
    parent:"ಪೋಷಕ",
    owner:"ಮಾಲೀಕ",
    trustee:"ಟ್ರಸ್ಟಿ",
    institution:"ಸಂಸ್ಥೆ",
    mess:"ಮೆಸ್",
    transporter:"ಸಾರಿಗೆದಾರ",
    huma:"HUMA",
    completed:"ಪೂರ್ಣಗೊಂಡಿದೆ",
    priority:"ಪ್ರಾಥಮಿಕ",
    recurring:"ಪುನರಾವರ್ತಿತ",
    createRCA:"RCA ರಚಿಸಿ",
    createRCADesc:"ಸಮಸ್ಯೆಗಳನ್ನು ದಾಖಲಿಸಿ, ಮೂಲ ಕಾರಣಗಳನ್ನು ಗುರುತಿಸಿ ಮತ್ತು ನಿರಂತರ ಸುಧಾರಣೆಗೆ ತಿದ್ದುಪಡಿ ಕ್ರಮಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
    editRCA:"RCA ಸಂಪಾದಿಸಿ",
    updateSelectedRCA:"ಆಯ್ಕೆ ಮಾಡಿದ RCA ನವೀಕರಿಸಿ",
    rcaDate:"RCA ದಿನಾಂಕ",
    rcaType:"RCA ಪ್ರಕಾರ",
    rcaFor:"RCA ಗಾಗಿ",
    rcaBy:"RCA ರಚಿಸಿದವರು",
    rcaCode:"RCA ಕೋಡ್",
    rcaGroupCode:"RCA ಗುಂಪು ಕೋಡ್",
    userRCAID:"ಬಳಕೆದಾರ RCA ID",
    category:"ವರ್ಗ",
    subCategory:"ಉಪವರ್ಗ",
    concernArea:"ಕಳವಳ ಪ್ರದೇಶ",
    title:"ಶೀರ್ಷಿಕೆ",
    description:"ವಿವರಣೆ",
    problemStatement:"ಸಮಸ್ಯೆಯ ವಿವರ",
    rootCause:"ಮೂಲ ಕಾರಣ",
    summary:"ಸಾರಾಂಶ",
    remarks:"ಟಿಪ್ಪಣಿಗಳು",
    additionalRemarks:"ಹೆಚ್ಚುವರಿ ಟಿಪ್ಪಣಿಗಳು",
    why1:"ಏಕೆ 1",
    why2:"ಏಕೆ 2",
    why3:"ಏಕೆ 3",
    why4:"ಏಕೆ 4",
    why5:"ಏಕೆ 5",
    quickSolutions:"ತ್ವರಿತ ಪರಿಹಾರಗಳು",
    quickSolutionsNote:"ತ್ವರಿತ ಪರಿಹಾರ ಟಿಪ್ಪಣಿ",
    quickSolutionsSelectionNote:"ಆಯ್ಕೆ ಮಾಡಿದ ಪರಿಹಾರ ಟಿಪ್ಪಣಿ",
    quickSolutionsActionsNote:"ಪರಿಹಾರ ಕ್ರಮ ಟಿಪ್ಪಣಿ",
    quickImpactNotes:"ತ್ವರಿತ ಪರಿಣಾಮ ಟಿಪ್ಪಣಿಗಳು",
    name:"ಹೆಸರು",
    nameCode:"ಹೆಸರು ಕೋಡ್",
    who_suggested:"ಯಾರು ಸೂಚಿಸಿದರು",
    enterTitle:"RCA ಶೀರ್ಷಿಕೆ ನಮೂದಿಸಿ",
    enterDescription:"RCA ವಿವರಣೆ ನಮೂದಿಸಿ",
    enterRemarks:"ಟಿಪ್ಪಣಿಗಳನ್ನು ನಮೂದಿಸಿ",
    enterProblemStatement:"ಸಮಸ್ಯೆಯ ವಿವರ ನೀಡಿ",
    enterRootCause:"ಗುರುತಿಸಿದ ಮೂಲ ಕಾರಣ ನಮೂದಿಸಿ",
    enterSummary:"ಸಾರಾಂಶ ನಮೂದಿಸಿ",
    enterConcernArea:"ಕಳವಳ ಪ್ರದೇಶ ನಮೂದಿಸಿ",
    enterTags:"ಉದಾ. ಶಿಸ್ತು, ಸತತತೆ, ಬೆಳವಣಿಗೆ",
    enterName:"ಹೆಸರು ನಮೂದಿಸಿ",
    enterNameCode:"ಹೆಸರು ಕೋಡ್ ನಮೂದಿಸಿ",
    selectType:"ಪ್ರಕಾರ ಆಯ್ಕೆಮಾಡಿ",
    selfType:"ಸ್ವಯಂ",
    parentType:"ಪೋಷಕ",
    managerType:"ಮ್ಯಾನೇಜರ್",
    ownerType:"ಮಾಲೀಕ",
    messType:"ಮೆಸ್",
    transportType:"ಸಾರಿಗೆ",
    friendType:"ಸ್ನೇಹಿತ",
    institutionType:"ಸಂಸ್ಥೆ",
    adminType:"ನಿರ್ವಾಹಕ",
    humaType:"HUMA",
    othersType:"ಇತರೆ",
    tags:"ಟ್ಯಾಗ್‌ಗಳು",
    addTags:"ಟ್ಯಾಗ್‌ಗಳನ್ನು ಸೇರಿಸಿ",
    active:"ಸಕ್ರಿಯ",
    inactive:"ನಿಷ್ಕ್ರಿಯ",
    isActive:"ಸಕ್ರಿಯವಾಗಿದೆ",
    isCompleted:"ಪೂರ್ಣಗೊಂಡಿದೆ",
    isRecurring:"ಪುನರಾವರ್ತಿತವಾಗಿದೆ",
    isPriority:"ಪ್ರಾಥಮಿಕವಾಗಿದೆ",
    isFinal:"ಅಂತಿಮವಾಗಿದೆ",
    recurringIssue:"ಪುನರಾವರ್ತಿತ ಸಮಸ್ಯೆ",
    markAsCompleted:"ಪೂರ್ಣಗೊಂಡಂತೆ ಗುರುತಿಸಿ",
    refineWithAI:"AI ಸಹಾಯದಿಂದ ಸುಧಾರಿಸಿ",
    aiAssistant:"AI ಸಹಾಯಕ",
    generatedByAI:"AI ರಚಿಸಿದೆ",
    createdByHuman:"ಮಾನವ ರಚಿಸಿದ್ದಾರೆ",
    missingri:"ಅಗತ್ಯ ಮಾಹಿತಿ ಕಾಣೆಯಾಗಿದೆ",
    plfillthefield:"ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಕ್ಷೇತ್ರವನ್ನು ಭರ್ತಿ ಮಾಡಿ",
    aiAnalysis:"AI ವಿಶ್ಲೇಷಣೆ",
    aiSuggestions:"AI ಸಲಹೆಗಳು",
    aiSummary:"AI ಸಾರಾಂಶ",
    ttsEnabled:"TTS ಸಕ್ರಿಯಗೊಂಡಿದೆ",
    enableTTS:"ಪಠ್ಯದಿಂದ ಧ್ವನಿ ಸಕ್ರಿಯಗೊಳಿಸಿ",
    evi:"ಧ್ವನಿ ಇನ್‌ಪುಟ್ ಸಕ್ರಿಯಗೊಳಿಸಿ",
    speechInput:"ಧ್ವನಿ ಇನ್‌ಪುಟ್",
    microphoneEnabled:"ಮೈಕ್ರೋಫೋನ್ ಸಕ್ರಿಯವಾಗಿದೆ",
    clickMicToSpeak:"ಮೈಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ಧ್ವನಿ ಇನ್‌ಪುಟ್‌ಗಾಗಿ ಮಾತನಾಡಿ...",
    writeHere:"ಇಲ್ಲಿ ಬರೆಯಿರಿ...",
    writeOrSpeak:"ಇಲ್ಲಿ ಬರೆಯಿರಿ ಅಥವಾ ಧ್ವನಿ ಇನ್‌ಪುಟ್‌ಗಾಗಿ ಮೈಕ್ ಬಳಸಿ...",
    play:"ಆಡಿಸಿ",
    pause:"ವಿರಾಮ",
    stop:"ನಿಲ್ಲಿಸಿ",
    resume:"ಮರುಪ್ರಾರಂಭಿಸಿ",
    addRCA:"RCA ಸೇರಿಸಿ",
    save:"ಉಳಿಸಿ",
    saveData:"ಡೇಟಾ ಉಳಿಸಿ",
    saving:"ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
    update:"ನವೀಕರಿಸಿ",
    updating:"ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ...",
    delete:"ಅಳಿಸಿ",
    deleting:"ಅಳಿಸಲಾಗುತ್ತಿದೆ...",
    cancel:"ರದ್ದುಮಾಡಿ",
    edit:"ಸಂಪಾದಿಸಿ",
    close:"ಮುಚ್ಚಿ",
    retry:"ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    savedSuccessfully:"ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ",
    updatedSuccessfully:"ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ",
    deletedSuccessfully:"ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
    saveFailed:"ಉಳಿಸುವುದು ವಿಫಲವಾಗಿದೆ",
    updateFailed:"ನವೀಕರಣ ವಿಫಲವಾಗಿದೆ",
    deleteFailed:"ಅಳಿಸುವುದು ವಿಫಲವಾಗಿದೆ",
    failedToLoadRCA:"RCA ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    titleDescriptionRequired:"ಶೀರ್ಷಿಕೆ ಮತ್ತು ವಿವರಣೆ ಅಗತ್ಯವಿದೆ",
    noDataFound:"ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    loading:"ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    fromDate:"ಆರಂಭ ದಿನಾಂಕ",
    toDate:"ಅಂತ್ಯ ದಿನಾಂಕ",
    completionDate:"ಪೂರ್ಣಗೊಂಡ ದಿನಾಂಕ",
    createdAt:"ರಚಿಸಿದ ದಿನಾಂಕ",
    updatedAt:"ನವೀಕರಿಸಿದ ದಿನಾಂಕ",
    actions:"ಕ್ರಿಯೆಗಳು",
    status:"ಸ್ಥಿತಿ",
    filter:"ಫಿಲ್ಟರ್",
    search:"ಹುಡುಕಿ",
    viewDetails:"ವಿವರಗಳನ್ನು ನೋಡಿ",
    assistantCode:"ಸಹಾಯಕ ಕೋಡ್",
    supervisorCode:"ಮೇಲ್ವಿಚಾರಕ ಕೋಡ್",
    human:"ಮಾನವ",
    ai:"AI",
    reply:"ಪ್ರತ್ಯುತ್ತರ",
    replyDate:"ಪ್ರತ್ಯುತ್ತರ ದಿನಾಂಕ",
    addReply:"ಪ್ರತ್ಯುತ್ತರ ಸೇರಿಸಿ",
    yes:"ಹೌದು",
    no:"ಇಲ್ಲ",
    enabled:"ಸಕ್ರಿಯ",
    disabled:"ನಿಷ್ಕ್ರಿಯ",
    Gratitude:"ಕೃತಜ್ಞತೆ",
    rca:"ಮೂಲ ಕಾರಣ ವಿಶ್ಲೇಷಣೆ",
    rcaSub:"ಸಮಸ್ಯೆಗಳನ್ನು ಗುರುತಿಸಿ, ಸಂರಚಿತ RCA ವಿಧಾನಗಳ ಮೂಲಕ ಮೂಲ ಕಾರಣಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ ಮತ್ತು ಹಾಸ್ಟೆಲ್ ಕಾರ್ಯಾಚರಣೆ, ಶಿಸ್ತು, ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸಂಸ್ಥೆಯ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಸುಧಾರಿಸಿ.",
    create:"ರಚಿಸಿ",
    list:"ಪಟ್ಟಿ",
    dashboard:"ಡ್ಯಾಶ್‌ಬೋರ್ಡ್"      
  },

  ml: {
    analytics:"വിശകലനം",
    reports:"റിപ്പോർട്ടുകൾ",
    settings:"ക്രമീകരണങ്ങൾ",
    all:"എല്ലാം",
    today:"ഇന്ന്",
    yesterday:"ഇന്നലെ",
    tomorrow:"നാളെ",
    thisweek:"ഈ ആഴ്ച",
    lastweek:"കഴിഞ്ഞ ആഴ്ച",
    nextweek:"അടുത്ത ആഴ്ച",
    thismonth:"ഈ മാസം",
    lastmonth:"കഴിഞ്ഞ മാസം",
    nextmonth:"അടുത്ത മാസം",
    self:"സ്വയം",
    myself:"എന്റെ സ്വന്തം RCA",
    tome:"എനിക്ക് നൽകിയിരിക്കുന്നത്",
    fromme:"എന്നിൽ നിന്ന് സൃഷ്ടിച്ചത്",
    student:"വിദ്യാർത്ഥി",
    parent:"രക്ഷിതാവ്",
    owner:"ഉടമ",
    trustee:"ട്രസ്റ്റി",
    institution:"സ്ഥാപനം",
    mess:"മെസ്",
    transporter:"ഗതാഗതക്കാരൻ",
    huma:"HUMA",
    completed:"പൂർത്തിയായി",
    priority:"പ്രാഥമികം",
    recurring:"ആവർത്തിക്കുന്നത്",
    createRCA:"RCA സൃഷ്ടിക്കുക",
    createRCADesc:"പ്രശ്നങ്ങൾ രേഖപ്പെടുത്തുക, മൂല കാരണങ്ങൾ കണ്ടെത്തുക, തുടർച്ചയായ മെച്ചപ്പെടുത്തലിനായി തിരുത്തൽ നടപടികൾ പിന്തുടരുക.",
    editRCA:"RCA തിരുത്തുക",
    updateSelectedRCA:"തിരഞ്ഞെടുത്ത RCA അപ്‌ഡേറ്റ് ചെയ്യുക",
    rcaDate:"RCA തീയതി",
    rcaType:"RCA തരം",
    rcaFor:"RCA വേണ്ടി",
    rcaBy:"RCA സൃഷ്ടിച്ചത്",
    rcaCode:"RCA കോഡ്",
    rcaGroupCode:"RCA ഗ്രൂപ്പ് കോഡ്",
    userRCAID:"ഉപയോക്തൃ RCA ID",
    category:"വിഭാഗം",
    subCategory:"ഉപവിഭാഗം",
    concernArea:"പ്രശ്ന മേഖല",
    title:"ശീർഷകം",
    description:"വിവരണം",
    problemStatement:"പ്രശ്ന വിവരണം",
    rootCause:"മൂല കാരണം",
    summary:"സംഗ്രഹം",
    remarks:"അഭിപ്രായങ്ങൾ",
    additionalRemarks:"കൂടുതൽ അഭിപ്രായങ്ങൾ",
    why1:"എന്തുകൊണ്ട് 1",
    why2:"എന്തുകൊണ്ട് 2",
    why3:"എന്തുകൊണ്ട് 3",
    why4:"എന്തുകൊണ്ട് 4",
    why5:"എന്തുകൊണ്ട് 5",
    quickSolutions:"വേഗത്തിലുള്ള പരിഹാരങ്ങൾ",
    quickSolutionsNote:"വേഗത്തിലുള്ള പരിഹാര കുറിപ്പ്",
    quickSolutionsSelectionNote:"തിരഞ്ഞെടുത്ത പരിഹാര കുറിപ്പ്",
    quickSolutionsActionsNote:"പരിഹാര പ്രവർത്തന കുറിപ്പ്",
    quickImpactNotes:"വേഗത്തിലുള്ള സ്വാധീന കുറിപ്പുകൾ",
    name:"പേര്",
    nameCode:"പേര് കോഡ്",
    who_suggested:"ആരാണ് നിർദേശിച്ചത്",
    enterTitle:"RCA ശീർഷകം നൽകുക",
    enterDescription:"RCA വിവരണം നൽകുക",
    enterRemarks:"അഭിപ്രായങ്ങൾ നൽകുക",
    enterProblemStatement:"പ്രശ്ന വിവരണം നൽകുക",
    enterRootCause:"കണ്ടെത്തിയ മൂല കാരണം നൽകുക",
    enterSummary:"സംഗ്രഹം നൽകുക",
    enterConcernArea:"പ്രശ്ന മേഖല നൽകുക",
    enterTags:"ഉദാ. ശാസനം, സ്ഥിരത, വളർച്ച",
    enterName:"പേര് നൽകുക",
    enterNameCode:"പേര് കോഡ് നൽകുക",
    selectType:"തരം തിരഞ്ഞെടുക്കുക",
    selfType:"സ്വയം",
    parentType:"രക്ഷിതാവ്",
    managerType:"മാനേജർ",
    ownerType:"ഉടമ",
    messType:"മെസ്",
    transportType:"ഗതാഗതം",
    friendType:"സുഹൃത്ത്",
    institutionType:"സ്ഥാപനം",
    adminType:"അഡ്മിൻ",
    humaType:"HUMA",
    othersType:"മറ്റുള്ളവർ",
    tags:"ടാഗുകൾ",
    addTags:"ടാഗുകൾ ചേർക്കുക",
    active:"സജീവം",
    inactive:"നിഷ്‌ക്രിയം",
    isActive:"സജീവമാണ്",
    isCompleted:"പൂർത്തിയായി",
    isRecurring:"ആവർത്തിക്കുന്നു",
    isPriority:"പ്രാധാന്യമുള്ളത്",
    isFinal:"അന്തിമം",
    recurringIssue:"ആവർത്തിക്കുന്ന പ്രശ്നം",
    markAsCompleted:"പൂർത്തിയായതായി അടയാളപ്പെടുത്തുക",
    refineWithAI:"AI ഉപയോഗിച്ച് മെച്ചപ്പെടുത്തുക",
    aiAssistant:"AI സഹായി",
    generatedByAI:"AI സൃഷ്ടിച്ചത്",
    createdByHuman:"മനുഷ്യൻ സൃഷ്ടിച്ചത്",
    missingri:"ആവശ്യമായ വിവരങ്ങൾ ലഭ്യമല്ല",
    plfillthefield:"ദയവായി താഴെക്കൊടുത്തിരിക്കുന്ന ഫീൽഡ് പൂരിപ്പിക്കുക",
    aiAnalysis:"AI വിശകലനം",
    aiSuggestions:"AI നിർദേശങ്ങൾ",
    aiSummary:"AI സംഗ്രഹം",
    ttsEnabled:"TTS സജീവമാണ്",
    enableTTS:"ടെക്സ്റ്റ് ടു സ്പീച്ച് സജീവമാക്കുക",
    evi:"ശബ്ദ ഇൻപുട്ട് സജീവമാക്കുക",
    speechInput:"ശബ്ദ ഇൻപുട്ട്",
    microphoneEnabled:"മൈക്രോഫോൺ സജീവമാണ്",
    clickMicToSpeak:"മൈക്ക് ക്ലിക്ക് ചെയ്ത് ശബ്ദ ഇൻപുട്ടിനായി സംസാരിക്കുക...",
    writeHere:"ഇവിടെ എഴുതുക...",
    writeOrSpeak:"ഇവിടെ എഴുതുക അല്ലെങ്കിൽ ശബ്ദ ഇൻപുട്ടിനായി മൈക്ക് ഉപയോഗിക്കുക...",
    play:"പ്ലേ",
    pause:"താൽക്കാലിക നിർത്തൽ",
    stop:"നിർത്തുക",
    resume:"തുടരുക",
    addRCA:"RCA ചേർക്കുക",
    save:"സംരക്ഷിക്കുക",
    saveData:"ഡാറ്റ സംരക്ഷിക്കുക",
    saving:"സംരക്ഷിക്കുന്നു...",
    update:"അപ്‌ഡേറ്റ് ചെയ്യുക",
    updating:"അപ്‌ഡേറ്റ് ചെയ്യുന്നു...",
    delete:"ഇല്ലാതാക്കുക",
    deleting:"ഇല്ലാതാക്കുന്നു...",
    cancel:"റദ്ദാക്കുക",
    edit:"തിരുത്തുക",
    close:"അടയ്ക്കുക",
    retry:"വീണ്ടും ശ്രമിക്കുക",
    savedSuccessfully:"വിജയകരമായി സംരക്ഷിച്ചു",
    updatedSuccessfully:"വിജയകരമായി അപ്‌ഡേറ്റ് ചെയ്തു",
    deletedSuccessfully:"വിജയകരമായി ഇല്ലാതാക്കി",
    saveFailed:"സംരക്ഷിക്കൽ പരാജയപ്പെട്ടു",
    updateFailed:"അപ്‌ഡേറ്റ് പരാജയപ്പെട്ടു",
    deleteFailed:"ഇല്ലാതാക്കൽ പരാജയപ്പെട്ടു",
    failedToLoadRCA:"RCA ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    titleDescriptionRequired:"ശീർഷകവും വിവരണവും ആവശ്യമാണ്",
    noDataFound:"ഡാറ്റ കണ്ടെത്തിയില്ല",
    loading:"ലോഡ് ചെയ്യുന്നു...",
    fromDate:"ആരംഭ തീയതി",
    toDate:"അവസാന തീയതി",
    completionDate:"പൂർത്തിയായ തീയതി",
    createdAt:"സൃഷ്ടിച്ച തീയതി",
    updatedAt:"അപ്‌ഡേറ്റ് ചെയ്ത തീയതി",
    actions:"പ്രവർത്തനങ്ങൾ",
    status:"സ്ഥിതി",
    filter:"ഫിൽറ്റർ",
    search:"തിരയുക",
    viewDetails:"വിശദാംശങ്ങൾ കാണുക",
    assistantCode:"സഹായി കോഡ്",
    supervisorCode:"സൂപ്പർവൈസർ കോഡ്",
    human:"മനുഷ്യൻ",
    ai:"AI",
    reply:"മറുപടി",
    replyDate:"മറുപടി തീയതി",
    addReply:"മറുപടി ചേർക്കുക",
    yes:"അതെ",
    no:"ഇല്ല",
    enabled:"സജീവം",
    disabled:"നിഷ്‌ക്രിയം",
    Gratitude:"കൃതജ്ഞത",
    rca:"മൂല കാരണ വിശകലനം",
    rcaSub:"പ്രശ്നങ്ങൾ തിരിച്ചറിയുക, ക്രമബദ്ധമായ RCA രീതികൾ ഉപയോഗിച്ച് മൂല കാരണങ്ങൾ വിശകലനം ചെയ്യുക, ഹോസ്റ്റൽ പ്രവർത്തനങ്ങൾ, ശാസനം, അടിസ്ഥാന സൗകര്യങ്ങൾ, സ്ഥാപന സംവിധാനങ്ങൾ എന്നിവ മെച്ചപ്പെടുത്തുക.",
    create:"സൃഷ്ടിക്കുക",
    list:"പട്ടിക",
    dashboard:"ഡാഷ്ബോർഡ്"
  },

  pa: {
    analytics:"ਵਿਸ਼ਲੇਸ਼ਣ",
    reports:"ਰਿਪੋਰਟਾਂ",
    settings:"ਸੈਟਿੰਗਾਂ",
    all:"ਸਭ",
    today:"ਅੱਜ",
    yesterday:"ਕੱਲ੍ਹ",
    tomorrow:"ਭਲਕੇ",
    thisweek:"ਇਹ ਹਫ਼ਤਾ",
    lastweek:"ਪਿਛਲਾ ਹਫ਼ਤਾ",
    nextweek:"ਅਗਲਾ ਹਫ਼ਤਾ",
    thismonth:"ਇਹ ਮਹੀਨਾ",
    lastmonth:"ਪਿਛਲਾ ਮਹੀਨਾ",
    nextmonth:"ਅਗਲਾ ਮਹੀਨਾ",
    self:"ਆਪਣਾ",
    myself:"ਮੇਰਾ ਆਪਣਾ RCA",
    tome:"ਮੈਨੂੰ ਸੌਂਪਿਆ ਗਿਆ",
    fromme:"ਮੇਰੇ ਵੱਲੋਂ ਬਣਾਇਆ ਗਿਆ",
    student:"ਵਿਦਿਆਰਥੀ",
    parent:"ਮਾਤਾ-ਪਿਤਾ",
    owner:"ਮਾਲਕ",
    trustee:"ਟਰੱਸਟੀ",
    institution:"ਸੰਸਥਾ",
    mess:"ਮੇਸ",
    transporter:"ਟ੍ਰਾਂਸਪੋਰਟਰ",
    huma:"HUMA",
    completed:"ਪੂਰਾ ਹੋਇਆ",
    priority:"ਤਰਜੀਹੀ",
    recurring:"ਮੁੜ-ਮੁੜ ਆਉਣ ਵਾਲਾ",
    createRCA:"RCA ਬਣਾਓ",
    createRCADesc:"ਸਮੱਸਿਆਵਾਂ ਦਰਜ ਕਰੋ, ਮੂਲ ਕਾਰਣਾਂ ਦੀ ਪਛਾਣ ਕਰੋ ਅਤੇ ਨਿਰੰਤਰ ਸੁਧਾਰ ਲਈ ਸੁਧਾਰਾਤਮਕ ਕਾਰਵਾਈਆਂ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ।",
    editRCA:"RCA ਸੋਧੋ",
    updateSelectedRCA:"ਚੁਣਿਆ ਗਿਆ RCA ਅੱਪਡੇਟ ਕਰੋ",
    rcaDate:"RCA ਮਿਤੀ",
    rcaType:"RCA ਕਿਸਮ",
    rcaFor:"RCA ਲਈ",
    rcaBy:"RCA ਬਣਾਇਆ",
    rcaCode:"RCA ਕੋਡ",
    rcaGroupCode:"RCA ਗਰੁੱਪ ਕੋਡ",
    userRCAID:"ਯੂਜ਼ਰ RCA ID",
    category:"ਸ਼੍ਰੇਣੀ",
    subCategory:"ਉਪ ਸ਼੍ਰੇਣੀ",
    concernArea:"ਚਿੰਤਾ ਖੇਤਰ",
    title:"ਸਿਰਲੇਖ",
    description:"ਵੇਰਵਾ",
    problemStatement:"ਸਮੱਸਿਆ ਦਾ ਵੇਰਵਾ",
    rootCause:"ਮੂਲ ਕਾਰਣ",
    summary:"ਸੰਖੇਪ",
    remarks:"ਟਿੱਪਣੀਆਂ",
    additionalRemarks:"ਵਾਧੂ ਟਿੱਪਣੀਆਂ",
    why1:"ਕਿਉਂ 1",
    why2:"ਕਿਉਂ 2",
    why3:"ਕਿਉਂ 3",
    why4:"ਕਿਉਂ 4",
    why5:"ਕਿਉਂ 5",
    quickSolutions:"ਤੁਰੰਤ ਹੱਲ",
    quickSolutionsNote:"ਤੁਰੰਤ ਹੱਲ ਨੋਟ",
    quickSolutionsSelectionNote:"ਚੁਣਿਆ ਗਿਆ ਹੱਲ ਨੋਟ",
    quickSolutionsActionsNote:"ਹੱਲ ਕਾਰਵਾਈ ਨੋਟ",
    quickImpactNotes:"ਤੁਰੰਤ ਪ੍ਰਭਾਵ ਨੋਟ",
    name:"ਨਾਮ",
    nameCode:"ਨਾਮ ਕੋਡ",
    who_suggested:"ਕਿਸਨੇ ਸੁਝਾਅ ਦਿੱਤਾ",
    enterTitle:"RCA ਸਿਰਲੇਖ ਦਰਜ ਕਰੋ",
    enterDescription:"RCA ਵੇਰਵਾ ਦਰਜ ਕਰੋ",
    enterRemarks:"ਟਿੱਪਣੀਆਂ ਦਰਜ ਕਰੋ",
    enterProblemStatement:"ਸਮੱਸਿਆ ਦਾ ਵੇਰਵਾ ਦਿਓ",
    enterRootCause:"ਪਛਾਣਿਆ ਗਿਆ ਮੂਲ ਕਾਰਣ ਦਰਜ ਕਰੋ",
    enterSummary:"ਸੰਖੇਪ ਦਰਜ ਕਰੋ",
    enterConcernArea:"ਚਿੰਤਾ ਖੇਤਰ ਦਰਜ ਕਰੋ",
    enterTags:"ਉਦਾਹਰਨ: ਅਨੁਸ਼ਾਸਨ, ਨਿਰੰਤਰਤਾ, ਵਿਕਾਸ",
    enterName:"ਨਾਮ ਦਰਜ ਕਰੋ",
    enterNameCode:"ਨਾਮ ਕੋਡ ਦਰਜ ਕਰੋ",
    selectType:"ਕਿਸਮ ਚੁਣੋ",
    selfType:"ਆਪਣਾ",
    parentType:"ਮਾਤਾ-ਪਿਤਾ",
    managerType:"ਮੈਨੇਜਰ",
    ownerType:"ਮਾਲਕ",
    messType:"ਮੇਸ",
    transportType:"ਟ੍ਰਾਂਸਪੋਰਟ",
    friendType:"ਦੋਸਤ",
    institutionType:"ਸੰਸਥਾ",
    adminType:"ਐਡਮਿਨ",
    humaType:"HUMA",
    othersType:"ਹੋਰ",
    tags:"ਟੈਗ",
    addTags:"ਟੈਗ ਸ਼ਾਮਲ ਕਰੋ",
    active:"ਸਕ੍ਰਿਆ",
    inactive:"ਗੈਰ-ਸਕ੍ਰਿਆ",
    isActive:"ਸਕ੍ਰਿਆ ਹੈ",
    isCompleted:"ਪੂਰਾ ਹੋਇਆ",
    isRecurring:"ਮੁੜ ਆ ਰਿਹਾ ਹੈ",
    isPriority:"ਤਰਜੀਹੀ ਹੈ",
    isFinal:"ਅੰਤਿਮ ਹੈ",
    recurringIssue:"ਮੁੜ ਆਉਣ ਵਾਲੀ ਸਮੱਸਿਆ",
    markAsCompleted:"ਪੂਰਾ ਹੋਇਆ ਨਿਸ਼ਾਨ ਲਗਾਓ",
    refineWithAI:"AI ਨਾਲ ਸੁਧਾਰੋ",
    aiAssistant:"AI ਸਹਾਇਕ",
    generatedByAI:"AI ਦੁਆਰਾ ਬਣਾਇਆ ਗਿਆ",
    createdByHuman:"ਇਨਸਾਨ ਦੁਆਰਾ ਬਣਾਇਆ ਗਿਆ",
    missingri:"ਲੋੜੀਂਦੀ ਜਾਣਕਾਰੀ ਗੁੰਮ ਹੈ",
    plfillthefield:"ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਦਿੱਤਾ ਖੇਤਰ ਭਰੋ",
    aiAnalysis:"AI ਵਿਸ਼ਲੇਸ਼ਣ",
    aiSuggestions:"AI ਸੁਝਾਅ",
    aiSummary:"AI ਸੰਖੇਪ",
    ttsEnabled:"TTS ਚਾਲੂ ਹੈ",
    enableTTS:"ਟੈਕਸਟ ਤੋਂ ਆਵਾਜ਼ ਚਾਲੂ ਕਰੋ",
    evi:"ਆਵਾਜ਼ ਇਨਪੁੱਟ ਚਾਲੂ ਕਰੋ",
    speechInput:"ਆਵਾਜ਼ ਇਨਪੁੱਟ",
    microphoneEnabled:"ਮਾਈਕ੍ਰੋਫੋਨ ਚਾਲੂ ਹੈ",
    clickMicToSpeak:"ਆਵਾਜ਼ ਇਨਪੁੱਟ ਲਈ ਮਾਈਕ 'ਤੇ ਕਲਿੱਕ ਕਰੋ ਅਤੇ ਬੋਲੋ...",
    writeHere:"ਇੱਥੇ ਲਿਖੋ...",
    writeOrSpeak:"ਇੱਥੇ ਲਿਖੋ ਜਾਂ ਆਵਾਜ਼ ਇਨਪੁੱਟ ਲਈ ਮਾਈਕ ਵਰਤੋ...",
    play:"ਚਲਾਓ",
    pause:"ਰੋਕੋ",
    stop:"ਬੰਦ ਕਰੋ",
    resume:"ਮੁੜ ਚਲਾਓ",
    addRCA:"RCA ਸ਼ਾਮਲ ਕਰੋ",
    save:"ਸੰਭਾਲੋ",
    saveData:"ਡਾਟਾ ਸੰਭਾਲੋ",
    saving:"ਸੰਭਾਲਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    update:"ਅੱਪਡੇਟ ਕਰੋ",
    updating:"ਅੱਪਡੇਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    delete:"ਮਿਟਾਓ",
    deleting:"ਮਿਟਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
    cancel:"ਰੱਦ ਕਰੋ",
    edit:"ਸੋਧੋ",
    close:"ਬੰਦ ਕਰੋ",
    retry:"ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    savedSuccessfully:"ਸਫਲਤਾਪੂਰਵਕ ਸੰਭਾਲਿਆ ਗਿਆ",
    updatedSuccessfully:"ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ",
    deletedSuccessfully:"ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾਇਆ ਗਿਆ",
    saveFailed:"ਸੰਭਾਲਣਾ ਅਸਫਲ ਰਿਹਾ",
    updateFailed:"ਅੱਪਡੇਟ ਅਸਫਲ ਰਿਹਾ",
    deleteFailed:"ਮਿਟਾਉਣਾ ਅਸਫਲ ਰਿਹਾ",
    failedToLoadRCA:"RCA ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    titleDescriptionRequired:"ਸਿਰਲੇਖ ਅਤੇ ਵੇਰਵਾ ਲਾਜ਼ਮੀ ਹਨ",
    noDataFound:"ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ",
    loading:"ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    fromDate:"ਸ਼ੁਰੂ ਮਿਤੀ",
    toDate:"ਅੰਤ ਮਿਤੀ",
    completionDate:"ਪੂਰਾ ਹੋਣ ਦੀ ਮਿਤੀ",
    createdAt:"ਬਣਾਉਣ ਦੀ ਮਿਤੀ",
    updatedAt:"ਅੱਪਡੇਟ ਮਿਤੀ",
    actions:"ਕਾਰਵਾਈਆਂ",
    status:"ਸਥਿਤੀ",
    filter:"ਫਿਲਟਰ",
    search:"ਖੋਜੋ",
    viewDetails:"ਵੇਰਵੇ ਵੇਖੋ",
    assistantCode:"ਸਹਾਇਕ ਕੋਡ",
    supervisorCode:"ਸੁਪਰਵਾਈਜ਼ਰ ਕੋਡ",
    human:"ਇਨਸਾਨ",
    ai:"AI",
    reply:"ਜਵਾਬ",
    replyDate:"ਜਵਾਬ ਮਿਤੀ",
    addReply:"ਜਵਾਬ ਸ਼ਾਮਲ ਕਰੋ",
    yes:"ਹਾਂ",
    no:"ਨਹੀਂ",
    enabled:"ਚਾਲੂ",
    disabled:"ਬੰਦ",
    Gratitude:"ਕ੍ਰਿਤਜਤਾ",
    rca:"ਮੂਲ ਕਾਰਣ ਵਿਸ਼ਲੇਸ਼ਣ",
    rcaSub:"ਸਮੱਸਿਆਵਾਂ ਦੀ ਪਛਾਣ ਕਰੋ, ਸੰਰਚਿਤ RCA ਤਰੀਕਿਆਂ ਨਾਲ ਮੂਲ ਕਾਰਣਾਂ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰੋ ਅਤੇ ਹੋਸਟਲ ਪ੍ਰਬੰਧਨ, ਅਨੁਸ਼ਾਸਨ, ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਅਤੇ ਸੰਸਥਾਗਤ ਪ੍ਰਣਾਲੀਆਂ ਵਿੱਚ ਸੁਧਾਰ ਕਰੋ।",
    create:"ਬਣਾਓ",
    list:"ਸੂਚੀ",
    dashboard:"ਡੈਸ਼ਬੋਰਡ"    
  },

  as: {
    analytics:"বিশ্লেষণ",
    reports:"ৰিপ'ৰ্টসমূহ",
    settings:"ছেটিংছ",
    all:"সকলো",
    today:"আজি",
    yesterday:"কালি",
    tomorrow:"কাইলৈ",
    thisweek:"এই সপ্তাহ",
    lastweek:"যোৱা সপ্তাহ",
    nextweek:"আগন্তুক সপ্তাহ",
    thismonth:"এই মাহ",
    lastmonth:"যোৱা মাহ",
    nextmonth:"আগন্তুক মাহ",
    self:"নিজ",
    myself:"মোৰ নিজৰ RCA",
    tome:"মোক নিযুক্ত কৰা হৈছে",
    fromme:"মোৰ দ্বাৰা সৃষ্টি কৰা",
    student:"ছাত্ৰ",
    parent:"অভিভাৱক",
    owner:"মালিক",
    trustee:"ট্ৰাষ্টী",
    institution:"প্ৰতিষ্ঠান",
    mess:"মেছ",
    transporter:"পৰিবহণকাৰী",
    huma:"HUMA",
    completed:"সম্পূৰ্ণ",
    priority:"অগ্ৰাধিকাৰ",
    recurring:"পুনৰাবৃত্ত",
    createRCA:"RCA সৃষ্টি কৰক",
    createRCADesc:"সমস্যাসমূহ লিপিবদ্ধ কৰক, মূল কাৰণ চিনাক্ত কৰক আৰু অবিৰত উন্নয়নৰ বাবে সংশোধনীমূলক পদক্ষেপ অনুসৰণ কৰক।",
    editRCA:"RCA সম্পাদনা কৰক",
    updateSelectedRCA:"নিৰ্বাচিত RCA আপডেট কৰক",
    rcaDate:"RCA তাৰিখ",
    rcaType:"RCA ধৰণ",
    rcaFor:"RCA কাৰণে",
    rcaBy:"RCA সৃষ্টি কৰিছে",
    rcaCode:"RCA ক'ড",
    rcaGroupCode:"RCA গোট ক'ড",
    userRCAID:"ব্যৱহাৰকাৰী RCA ID",
    category:"শ্ৰেণী",
    subCategory:"উপশ্ৰেণী",
    concernArea:"চিন্তাৰ ক্ষেত্ৰ",
    title:"শিৰোনাম",
    description:"বিৱৰণ",
    problemStatement:"সমস্যাৰ বিৱৰণ",
    rootCause:"মূল কাৰণ",
    summary:"সাৰাংশ",
    remarks:"মন্তব্য",
    additionalRemarks:"অতিৰিক্ত মন্তব্য",
    why1:"কিয় ১",
    why2:"কিয় ২",
    why3:"কিয় ৩",
    why4:"কিয় ৪",
    why5:"কিয় ৫",
    quickSolutions:"দ্ৰুত সমাধান",
    quickSolutionsNote:"দ্ৰুত সমাধান টোকা",
    quickSolutionsSelectionNote:"নিৰ্বাচিত সমাধান টোকা",
    quickSolutionsActionsNote:"সমাধান কাৰ্য টোকা",
    quickImpactNotes:"দ্ৰুত প্ৰভাৱ টোকা",
    name:"নাম",
    nameCode:"নাম ক'ড",
    who_suggested:"কোনে পৰামৰ্শ দিলে",
    enterTitle:"RCA শিৰোনাম লিখক",
    enterDescription:"RCA বিৱৰণ লিখক",
    enterRemarks:"মন্তব্য লিখক",
    enterProblemStatement:"সমস্যাৰ বিৱৰণ দিয়ক",
    enterRootCause:"চিনাক্ত কৰা মূল কাৰণ লিখক",
    enterSummary:"সাৰাংশ লিখক",
    enterConcernArea:"চিন্তাৰ ক্ষেত্ৰ লিখক",
    enterTags:"উদাহৰণ: শৃংখলা, ধাৰাবাহিকতা, উন্নতি",
    enterName:"নাম লিখক",
    enterNameCode:"নাম ক'ড লিখক",
    selectType:"ধৰণ বাছক",
    selfType:"নিজ",
    parentType:"অভিভাৱক",
    managerType:"মেনেজাৰ",
    ownerType:"মালিক",
    messType:"মেছ",
    transportType:"পৰিবহণ",
    friendType:"বন্ধু",
    institutionType:"প্ৰতিষ্ঠান",
    adminType:"এডমিন",
    humaType:"HUMA",
    othersType:"অন্যান্য",
    tags:"টেগসমূহ",
    addTags:"টেগ যোগ কৰক",
    active:"সক্ৰিয়",
    inactive:"নিষ্ক্ৰিয়",
    isActive:"সক্ৰিয় আছে",
    isCompleted:"সম্পূৰ্ণ হৈছে",
    isRecurring:"পুনৰাবৃত্ত হৈছে",
    isPriority:"অগ্ৰাধিকাৰ আছে",
    isFinal:"চূড়ান্ত",
    recurringIssue:"পুনৰাবৃত্ত সমস্যা",
    markAsCompleted:"সম্পূৰ্ণ বুলি চিহ্নিত কৰক",
    refineWithAI:"AI ৰ সহায়ত উন্নত কৰক",
    aiAssistant:"AI সহায়ক",
    generatedByAI:"AI দ্বাৰা সৃষ্টি কৰা",
    createdByHuman:"মানুহৰ দ্বাৰা সৃষ্টি কৰা",
    missingri:"প্ৰয়োজনীয় তথ্য অনুপস্থিত",
    plfillthefield:"অনুগ্ৰহ কৰি তলৰ ক্ষেত্ৰ পূৰণ কৰক",
    aiAnalysis:"AI বিশ্লেষণ",
    aiSuggestions:"AI পৰামৰ্শ",
    aiSummary:"AI সাৰাংশ",
    ttsEnabled:"TTS সক্ৰিয়",
    enableTTS:"টেক্সট টু স্পিচ সক্ৰিয় কৰক",
    evi:"ভইচ ইনপুট সক্ৰিয় কৰক",
    speechInput:"ভইচ ইনপুট",
    microphoneEnabled:"মাইক্ৰোফোন সক্ৰিয়",
    clickMicToSpeak:"ভইচ ইনপুটৰ বাবে মাইকত ক্লিক কৰি কওক...",
    writeHere:"ইয়াত লিখক...",
    writeOrSpeak:"ইয়াত লিখক বা ভইচ ইনপুটৰ বাবে মাইক ব্যৱহাৰ কৰক...",
    play:"চলাওক",
    pause:"বিৰতি",
    stop:"বন্ধ কৰক",
    resume:"পুনৰ আৰম্ভ কৰক",
    addRCA:"RCA যোগ কৰক",
    save:"সংৰক্ষণ কৰক",
    saveData:"ডাটা সংৰক্ষণ কৰক",
    saving:"সংৰক্ষণ কৰা হৈছে...",
    update:"আপডেট কৰক",
    updating:"আপডেট কৰা হৈছে...",
    delete:"মচি পেলাওক",
    deleting:"মচি পেলোৱা হৈছে...",
    cancel:"বাতিল কৰক",
    edit:"সম্পাদনা কৰক",
    close:"বন্ধ কৰক",
    retry:"পুনৰ চেষ্টা কৰক",
    savedSuccessfully:"সফলভাৱে সংৰক্ষণ কৰা হৈছে",
    updatedSuccessfully:"সফলভাৱে আপডেট কৰা হৈছে",
    deletedSuccessfully:"সফলভাৱে মচি পেলোৱা হৈছে",
    saveFailed:"সংৰক্ষণ ব্যৰ্থ হৈছে",
    updateFailed:"আপডেট ব্যৰ্থ হৈছে",
    deleteFailed:"মচি পেলোৱা ব্যৰ্থ হৈছে",
    failedToLoadRCA:"RCA লোড কৰিব পৰা নগ'ল",
    titleDescriptionRequired:"শিৰোনাম আৰু বিৱৰণ আৱশ্যক",
    noDataFound:"কোনো ডাটা পোৱা নগ'ল",
    loading:"লোড হৈ আছে...",
    fromDate:"আৰম্ভ তাৰিখ",
    toDate:"সমাপ্তিৰ তাৰিখ",
    completionDate:"সম্পূৰ্ণতাৰ তাৰিখ",
    createdAt:"সৃষ্টি কৰা তাৰিখ",
    updatedAt:"আপডেট কৰা তাৰিখ",
    actions:"কাৰ্যসমূহ",
    status:"স্থিতি",
    filter:"ফিল্টাৰ",
    search:"সন্ধান কৰক",
    viewDetails:"বিৱৰণ চাওক",
    assistantCode:"সহায়ক ক'ড",
    supervisorCode:"তদাৰককাৰী ক'ড",
    human:"মানুহ",
    ai:"AI",
    reply:"উত্তৰ",
    replyDate:"উত্তৰৰ তাৰিখ",
    addReply:"উত্তৰ যোগ কৰক",
    yes:"হয়",
    no:"নহয়",
    enabled:"সক্ৰিয়",
    disabled:"নিষ্ক্ৰিয়",
    Gratitude:"কৃতজ্ঞতা",
    rca:"মূল কাৰণ বিশ্লেষণ",
    rcaSub:"সমস্যাসমূহ চিনাক্ত কৰক, গঠনমূলক RCA পদ্ধতিৰ সহায়ত মূল কাৰণ বিশ্লেষণ কৰক আৰু হোষ্টেল পৰিচালনা, শৃংখলা, অবকাঠামো আৰু প্ৰতিষ্ঠানিক ব্যৱস্থাসমূহ উন্নত কৰক।",
    create:"সৃষ্টি কৰক",
    list:"তালিকা",
    dashboard:"ডেশ্বব'ৰ্ড"      
  },
};

export default msmeOwnerPATranslations;